<template>
  <div>
    <!-- Loading screen -->
    <div class="loading-box" v-if="loading">
      <div class="columns">
        <!-- Upload progress -->
        <div class="column">
          <img
            v-if="progressStatus == 0"
            src="../assets/upload-wait.png"
            class="progress-icon"
          />
          <img
            v-if="progressStatus == 1"
            src="../assets/upload.png"
            class="progress-icon"
          />
          <img
            v-if="
              progressStatus == 2 ||
                progressStatus == 3 ||
                progressStatus == 4 ||
                progressStatus == 5
            "
            src="../assets/upload-success.png"
            class="progress-icon"
          />
          <progress
            v-if="progressStatus == 0"
            class="progress"
            value="0"
          ></progress>
          <progress
            v-if="progressStatus == 1"
            :class="`progress is-warning`"
          ></progress>
          <progress
            v-if="
              progressStatus == 2 ||
                progressStatus == 3 ||
                progressStatus == 4 ||
                progressStatus == 5
            "
            :class="`progress is-success`"
            value="100"
          ></progress>
          <p class="progress-text">Upload Files</p>
        </div>
        <!-- End of upload progress -->

        <!-- Configuration Generation progress -->
        <div class="column" v-if="loading">
          <img
            v-if="progressStatus == 0 || progressStatus == 1"
            src="../assets/compute-wait.png"
            class="progress-icon"
          />
          <img
            v-if="progressStatus == 2"
            src="../assets/compute.png"
            class="progress-icon"
          />
          <img
            v-if="
              progressStatus == 3 || progressStatus == 4 || progressStatus == 5
            "
            src="../assets/compute-success.png"
            class="progress-icon"
          />
          <progress
            v-if="progressStatus == 0 || progressStatus == 1"
            class="progress"
            value="0"
          ></progress>
          <progress
            v-if="progressStatus == 2"
            :class="`progress is-warning`"
          ></progress>
          <progress
            v-if="
              progressStatus == 3 || progressStatus == 4 || progressStatus == 5
            "
            :class="`progress is-success`"
            value="100"
          ></progress>
          <p class="progress-text">Generate Configurations</p>
        </div>
        <!-- End of configuration generation progress -->

        <!-- Benchmark progress -->
        <div class="column">
          <img
            v-if="
              progressStatus == 0 || progressStatus == 1 || progressStatus == 2
            "
            src="../assets/compute-wait.png"
            class="progress-icon"
          />
          <img
            v-if="progressStatus == 3"
            src="../assets/compute.png"
            class="progress-icon"
          />
          <img
            v-if="progressStatus == 4 || progressStatus == 5"
            src="../assets/compute-success.png"
            class="progress-icon"
          />
          <progress
            v-if="
              progressStatus == 0 || progressStatus == 1 || progressStatus == 2
            "
            class="progress"
            value="0"
          ></progress>
          <!--
          <progress
            v-if="
              progressStatus == 3 || progressStatus == 4
            "
            :value="benchmarkProgress / 100"
            :class="
              benchmarkProgress == 100
                ? `progress is-success`
                : `progress is-warning`
            "
          ></progress>
          -->
          <progress
            v-if="progressStatus == 4 || progressStatus == 5"
            :class="`progress is-success`"
            value="100"
          ></progress>
          <p class="progress-text">
            Run Benchmark
            {{ progressStatus == 3 ? "(" + benchmarkProgress + "%)" : "" }}
          </p>
        </div>
        <!-- End of benchmark progress -->

        <!-- Getting result progress -->
        <div class="column">
          <img
            v-if="
              progressStatus == 0 ||
                progressStatus == 1 ||
                progressStatus == 2 ||
                progressStatus == 3
            "
            src="../assets/get-wait.png"
            class="progress-icon"
          />
          <img
            v-if="progressStatus == 4"
            src="../assets/get.png"
            class="progress-icon"
          />
          <img
            v-if="progressStatus == 5"
            src="../assets/get-sucess.png"
            class="progress-icon"
          />
          <progress
            v-if="
              progressStatus == 0 ||
                progressStatus == 1 ||
                progressStatus == 2 ||
                progressStatus == 3
            "
            class="progress"
            value="0"
          ></progress>
          <progress
            v-if="progressStatus == 4"
            :class="`progress is-warning`"
          ></progress>
          <progress
            v-if="progressStatus == 5"
            :class="`progress is-success`"
            value="100"
          ></progress>
          <p class="progress-text">Gather Result</p>
        </div>
        <!-- Getting result progress -->
      </div>
      <div class="notification-text">
        <i>
          <br />
          <div v-if="progressStatus == 1">
            <p>
              File upload in progress, plese do not close the tab or window.
            </p>
            <p>Otherwise, all of your progress will be lost!</p>
          </div>
          <p v-else-if="progressStatus == 2 && !longOp">
            Benchmark is running. Please wait for a while.
          </p>
          <div v-if="progressStatus == 2 && longOp">
            <img
              src="../assets/warn.png"
              style="height: 100px;
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    display: block;"
            />
            <p>Benchmark is running.</p>
            <p>
              You can safely close your browser and come back later to check
              result.
            </p>
          </div>
          <p v-if="progressStatus == 3">Getting your result.</p>
          <br />
        </i>
      </div>
    </div>
    <!-- End of loading screen -->

    <!-- Main menu -->
    <div v-if="!showModel" class="sized" style="padding-top:3%;">
      <img src="../assets/logo.png" class="logo" />
      <div class="columns">
        <div class="column">
          Object File
          <br />
          <div class="file has-name is-fullwidth">
            <label class="file-label">
              <input
                class="file-input"
                type="file"
                name="resume"
                @change="getFileLocally"
              />
              <span class="file-cta">
                <span class="file-icon">
                  <i class="fas fa-upload"></i>
                </span>
                <span class="file-label">Choose a file</span>
              </span>
              <span
                :class="
                  fileName
                    ? fileName.includes('.obj')
                      ? 'file-name success'
                      : 'file-name err'
                    : 'file-name'
                "
                >{{
                  fileName
                    ? fileName.substring(0, 12) + "..."
                    : "Please upload file"
                }}</span
              >
            </label>
          </div>
        </div>
        <!-- <div class="column">
          DISPLAY HEATMAP BASED ON :
          <br />
          <div class="select is-fullwidth">
            <select v-model="dispOption">
              <option value="med" selected>Median</option>
              <option value="max">Maximal</option>
              <option value="avg">Average</option>
            </select>
          </div>
        </div> -->
        <div class="column">
          Benchmark Mode
          <br />
          <div class="select is-fullwidth">
            <select v-model="benchMode">
              <option value="coll" selected>Collision</option>
              <option value="prox">Proximity</option>
            </select>
          </div>
        </div>
        <div v-if="benchMode == 'coll'" class="column">
          Algo
          <br />
          <div class="select is-fullwidth">
            <select v-model="algo">
              <option value="do">DopTree</option>
              <option value="bx">BoxTree</option>
              <option value="simdop" selected>SIMDop</option>
              <option value="pqp">PQP</option>
              <option value="vc">VCollide</option>
              <option value="custom">Custom Algorithm</option>
            </select>
          </div>
          <div v-if="algo == 'custom'">
            <div class="file has-name is-fullwidth">
            <label class="file-label">
              <input
                class="file-input"
                type="file"
                name="resume"
                @change="getAlgorithmLocally"
              />
              <span class="file-cta">
                <span class="file-icon">
                  <i class="fas fa-upload"></i>
                </span>
                <span class="file-label">Choose a .dll file</span>
              </span>
              <span
                :class="
                  algoFileName
                    ? algoFileName.includes('.dll')
                      ? 'file-name success'
                      : 'file-name err'
                    : 'file-name'
                "
                >{{
                  algoFileName
                    ? algoFileName.substring(0, 12) + "..."
                    : "Please upload file"
                }}</span
              >
            </label>
          </div>
          </div>
        </div>
        <div v-else-if="benchMode == 'prox'" class="column">
          Algo
          <br />
          <div class="select is-fullwidth">
            <select v-model="algo">
              <option value="simdop" selected>SIMDop</option>
              <option value="pqp">PQP</option>
            </select>
          </div>
        </div>
        <div
          v-if="algo != 'pqp' && algo != 'vc' && algo != 'bx'"
          class="column"
        >
          First / All Collision ?
          <br />
          <div class="select is-fullwidth">
            <select v-model="allPolygons">
              <option :value="true" selected>All</option>
              <option :value="false">First</option>
            </select>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          Benchmark Configurations:
          <br />
          <div class="select is-fullwidth">
            <select v-model="pos">
              <option value="generatePos" selected
                >Generate New Positions</option
              >
              <option value="savedPos" selected>Use Saved Positions</option>
              <option value="uploadPos">Upload Positions File</option>
            </select>
          </div>
        </div>

        <div v-if="pos != 'uploadPos'" class="column">
          Position Finding Method :
          <br />
          <div class="select is-fullwidth">
            <select v-model="posFindingMethod">
              <option value="sphere" selected>Sphere</option>
              <!--<option value="csphere">Csphere</option>-->
              <option value="grid">Grid</option>
            </select>
          </div>
        </div>
        <div
          v-if="posFindingMethod == 'sphere' && pos != 'uploadPos'"
          class="column"
        >
          Rotate Object By Degree
          <VueSlideBar
            v-model="rDeg"
            :min="0"
            :max="360"
            :tooltipStyles="{
              backgroundColor: 'orange',
              borderColor: 'orange',
              fontSize: '15px'
            }"
          ></VueSlideBar>
        </div>
        <div
          v-if="posFindingMethod == 'sphere' && pos != 'uploadPos'"
          class="column"
        >
          Move Object By Degree
          <VueSlideBar
            v-model="aDeg"
            :min="0"
            :max="360"
            :tooltipStyles="{
              backgroundColor: 'orange',
              borderColor: 'orange',
              fontSize: '15px'
            }"
          ></VueSlideBar>
        </div>
        <div
          v-if="posFindingMethod == 'grid' && pos != 'uploadPos'"
          class="column"
        >
          <div>
            Grid Size :
            <input
              type="radio"
              id="defaultsize"
              style="margin-right:10px;"
              value="defaultsize"
              checked
              v-model="gridsize"
            />
            Use default size
            <input
              type="radio"
              id="customsize"
              style="margin-right:10px;margin-left:10px"
              value="customsize"
              v-model="gridsize"
            />
            Custom size
            <div>
              x:
              <input
                class="input"
                type="number"
                style="width:100px;"
                min="0"
                v-model="xsize"
                :disabled="
                  gridsize ? (gridsize == 'customsize' ? false : true) : true
                "
              />
              y:
              <input
                class="input"
                type="number"
                style="width:100px;"
                min="0"
                v-model="ysize"
                :disabled="
                  gridsize ? (gridsize == 'customsize' ? false : true) : true
                "
              />
              z:
              <input
                class="input"
                type="number"
                style="width:100px;"
                min="0"
                v-model="zsize"
                :disabled="
                  gridsize ? (gridsize == 'customsize' ? false : true) : true
                "
              />
            </div>
          </div>
        </div>
        <div v-if="pos == 'uploadPos'" class="column">
          Configuration File :
          <br />
          <div class="file has-name is-fullwidth">
            <label class="file-label">
              <input
                class="file-input"
                type="file"
                name="posFile"
                @change="getPosFile"
              />
              <span class="file-cta">
                <span class="file-icon">
                  <i class="fas fa-upload"></i>
                </span>
                <span class="file-label">Choose a file…</span>
              </span>
              <span
                :class="
                  posFileName
                    ? posFileName.includes('.pos')
                      ? 'file-name success'
                      : 'file-name err'
                    : 'file-name'
                "
                >{{
                  posFileName
                    ? posFileName
                    : "Please upload your configuration file."
                }}</span
              >
            </label>
          </div>
        </div>
      </div>

      <br />
      <div class="columns">
        <div v-if="pos != 'uploadPos'" class="column">
          Relative Distance : {{ distance * 0.01 }}
          <!-- ( {{ distance }} x 0.0001 ) -->
          <VueSlideBar
            v-model="distance"
            :min="0"
            :max="100"
            :tooltipStyles="{
              backgroundColor: 'orange',
              borderColor: 'orange',
              fontSize: '15px'
            }"
          ></VueSlideBar>
        </div>
      </div>
      <div v-if="pos == 'generatePos'" class="column">
        Distance Algo :
        <br />
        <div class="select is-fullwidth">
          <select v-model="distAlgo">
            <option value="pqp" selected>PQP</option>
            <option value="simdop">SIMDop</option>
          </select>
        </div>
      </div>
      <input type="checkbox" id="saveObject" name="save" value="object" />
      <label for="saveObject">Remove object after benchmark</label>
      <button
        :class="
          `button ${
            fileName
              ? checkConfig()
                ? 'is-success'
                : 'is-danger'
              : ''
          } is-fullwidth`
        "
        :disabled="
          fileName ? !checkConfig() : true
        "
        @click="start()"
      >
        Start
      </button>
    </div>

    <!-- End of main menu -->

    <!-- Result page -->
    <div v-else>
      <!-- Top progress bar -->
      <progress
        v-if="progressInst + progressRuntime < 100"
        :value="progressInst + progressRuntime"
        class="progress is-warning"
        style="margin-bottom:0px;"
      ></progress>

      <div class="columns is-gapless" style=" height:94vh;">
        <!-- First column, summary and controls -->
        <div class="column is-3">
          <div class="dark-bg">
            <h2 class="title is-2 white">
              <i>
                Result
                <br />
              </i>
            </h2>
            <p>
              <b>Object name</b>
              <br />
              {{ description.objName }}
            </p>
            <br />
            <!-- <p>
              <b>Object format</b>
              <br />
              {{ description.objFormat }}
            </p>
            <br /> -->

            <b>Configurations</b>
            <p>Total : {{ this.closestPointsObj.count }}</p>
            <br />
            <!-- <b>Runtime</b>
            <p>Avg : {{ description.avgTime.toFixed(4) }}</p>
            <p>Min : {{ description.minTime.toFixed(4) }}</p>
            <p>Max : {{ description.maxTime.toFixed(4) }}</p>
            <br />
            <div v-if="algo != 'pqp' && algo != 'vc' && algo != 'bx'">
              <b>Intersections</b>
              <p>Avg : {{ Math.round(description.avgInts) }}</p>
              <p>Min : {{ Math.round(description.minInts) }}</p>
              <p>Max : {{ Math.round(description.maxInts) }}</p>
              <br />
            </div> -->
            <button
              :class="`button is-warning ${wireframeMode ? '' : 'is-outlined'}`"
              style="margin-top:10px; width : 300px"
              @click="switchWireframeMode()"
            >
              Wireframe : {{ wireframeMode ? "ON" : "OFF" }}
            </button>
            <br />
            <button
              :class="
                `button is-warning ${filterOutliersMode ? '' : 'is-outlined'}`
              "
              style="margin-top:10px; width : 300px"
              @click="switchFilterOutliersMode()"
            >
              Filter Outliers : {{ filterOutliersMode ? "ON" : "OFF" }}
            </button>
            <br />
            <!-- <button
              v-if="algo != 'pqp' && algo != 'vc' && algo != 'bx'"
              :class="`button is-warning ${dispMode ? '' : 'is-outlined'}`"
              style="margin-top:10px; width : 170px"
              @click="switchDispMode()"
            >
              Display : {{ dispMode ? "Intersection" : "Runtime" }}
            </button>
            <br /> -->
            <button
              :class="`button is-warning ${heatmapMode ? '' : 'is-outlined'}`"
              style="margin-top:10px; width : 300px"
              @click="switchHeatmapMode2()"
            >
              Display : {{ heatmapMode }}
            </button>
            <br />
            <button
              :class="
                `button is-warning ${viewClosestPoints ? '' : 'is-outlined'}`
              "
              style="margin-top:10px; width : 300px"
              @click="toggleClosestPoints()"
            >
              Closest Points : {{ viewClosestPoints ? "ON" : "OFF" }}
            </button>
            <br />

            <button
              :class="`button is-warning ${viewObject ? '' : 'is-outlined'}`"
              style="margin-top:10px; width : 300px"
              @click="toggleObject()"
            >
              Object : {{ viewObject ? "ON" : "OFF" }}
            </button>
            <br />

            <button
              class="button is-primary"
              style="margin-top:10px; width : 300px"
              @click="reloadPage()"
            >
              Back
            </button>
          </div>
        </div>
        <!-- End of first column -->

        <!-- Second column, 3D heatmap area -->
        <div
          v-on:click="onDocumentMouseDown"
          id="3dParent"
          class="column is-10"
        >
          <!-- 3D heatmap canvas -->
          <div id="3d"></div>
          <!-- Insight label -->
          <div id="textContainer"></div>
          <!-- ColorMap area -->
          <div>
            <canvas width="50" height="512" id="colorMap"></canvas>
          </div>
        </div>
      </div>
    </div>
    <!-- End of result page -->
  </div>
</template>

<script>
import * as THREE from "three";
import OBJLoader from "three-obj-loader";
import GLTFLoader from "three-gltf-loader";
import OrbitControls from "three-orbitcontrols";
import axios from "axios";
import VueSlideBar from "vue-slide-bar";
import { Lut } from "three/examples/jsm/math/Lut";
OBJLoader(THREE);
import { OBJLoader2 } from "three/examples/jsm/loaders/OBJLoader2.js";
let loader = new OBJLoader2();
var md5 = require('md5');

const heatmapModes = {
  TIMING: {
    AVERAGE: "Timing - Average",
    MEDIAN: "Timing - Median",
    MIN: "Timing - Min",
    MAX: "Timing - Max",
    SD: "Timing - StdDev",
    MEDIANAD: "Timing - MedianAD",
    FILTERAVERAGE: "Timing - Average - Filter",
    FILTERMEDIAN: "Timing - Median - Filter",
    FILTERMIN: "Timing - Min - Filter",
    FILTERMAX: "Timing - Max - Filter",
    FILTERSD: "Timing - StdDev - Filter",
    FILTERMEDIANAD: "Timing - MedianAD - Filter"
  },
  DENSITY: "Density",
  FILTERDENSITY: "Density - Filter",
  NONE: "Object",
  HIDE: "Hide Object"
};

const turbo_srgb_colors = [
  new THREE.Color(0.18995, 0.07176, 0.23217),
  new THREE.Color(0.19483, 0.08339, 0.26149),
  new THREE.Color(0.19956, 0.09498, 0.29024),
  new THREE.Color(0.20415, 0.10652, 0.31844),
  new THREE.Color(0.2086, 0.11802, 0.34607),
  new THREE.Color(0.21291, 0.12947, 0.37314),
  new THREE.Color(0.21708, 0.14087, 0.39964),
  new THREE.Color(0.22111, 0.15223, 0.42558),
  new THREE.Color(0.225, 0.16354, 0.45096),
  new THREE.Color(0.22875, 0.17481, 0.47578),
  new THREE.Color(0.23236, 0.18603, 0.50004),
  new THREE.Color(0.23582, 0.1972, 0.52373),
  new THREE.Color(0.23915, 0.20833, 0.54686),
  new THREE.Color(0.24234, 0.21941, 0.56942),
  new THREE.Color(0.24539, 0.23044, 0.59142),
  new THREE.Color(0.2483, 0.24143, 0.61286),
  new THREE.Color(0.25107, 0.25237, 0.63374),
  new THREE.Color(0.25369, 0.26327, 0.65406),
  new THREE.Color(0.25618, 0.27412, 0.67381),
  new THREE.Color(0.25853, 0.28492, 0.693),
  new THREE.Color(0.26074, 0.29568, 0.71162),
  new THREE.Color(0.2628, 0.30639, 0.72968),
  new THREE.Color(0.26473, 0.31706, 0.74718),
  new THREE.Color(0.26652, 0.32768, 0.76412),
  new THREE.Color(0.26816, 0.33825, 0.7805),
  new THREE.Color(0.26967, 0.34878, 0.79631),
  new THREE.Color(0.27103, 0.35926, 0.81156),
  new THREE.Color(0.27226, 0.3697, 0.82624),
  new THREE.Color(0.27334, 0.38008, 0.84037),
  new THREE.Color(0.27429, 0.39043, 0.85393),
  new THREE.Color(0.27509, 0.40072, 0.86692),
  new THREE.Color(0.27576, 0.41097, 0.87936),
  new THREE.Color(0.27628, 0.42118, 0.89123),
  new THREE.Color(0.27667, 0.43134, 0.90254),
  new THREE.Color(0.27691, 0.44145, 0.91328),
  new THREE.Color(0.27701, 0.45152, 0.92347),
  new THREE.Color(0.27698, 0.46153, 0.93309),
  new THREE.Color(0.2768, 0.47151, 0.94214),
  new THREE.Color(0.27648, 0.48144, 0.95064),
  new THREE.Color(0.27603, 0.49132, 0.95857),
  new THREE.Color(0.27543, 0.50115, 0.96594),
  new THREE.Color(0.27469, 0.51094, 0.97275),
  new THREE.Color(0.27381, 0.52069, 0.97899),
  new THREE.Color(0.27273, 0.5304, 0.98461),
  new THREE.Color(0.27106, 0.54015, 0.9893),
  new THREE.Color(0.26878, 0.54995, 0.99303),
  new THREE.Color(0.26592, 0.55979, 0.99583),
  new THREE.Color(0.26252, 0.56967, 0.99773),
  new THREE.Color(0.25862, 0.57958, 0.99876),
  new THREE.Color(0.25425, 0.5895, 0.99896),
  new THREE.Color(0.24946, 0.59943, 0.99835),
  new THREE.Color(0.24427, 0.60937, 0.99697),
  new THREE.Color(0.23874, 0.61931, 0.99485),
  new THREE.Color(0.23288, 0.62923, 0.99202),
  new THREE.Color(0.22676, 0.63913, 0.98851),
  new THREE.Color(0.22039, 0.64901, 0.98436),
  new THREE.Color(0.21382, 0.65886, 0.97959),
  new THREE.Color(0.20708, 0.66866, 0.97423),
  new THREE.Color(0.20021, 0.67842, 0.96833),
  new THREE.Color(0.19326, 0.68812, 0.9619),
  new THREE.Color(0.18625, 0.69775, 0.95498),
  new THREE.Color(0.17923, 0.70732, 0.94761),
  new THREE.Color(0.17223, 0.7168, 0.93981),
  new THREE.Color(0.16529, 0.7262, 0.93161),
  new THREE.Color(0.15844, 0.73551, 0.92305),
  new THREE.Color(0.15173, 0.74472, 0.91416),
  new THREE.Color(0.14519, 0.75381, 0.90496),
  new THREE.Color(0.13886, 0.76279, 0.8955),
  new THREE.Color(0.13278, 0.77165, 0.8858),
  new THREE.Color(0.12698, 0.78037, 0.8759),
  new THREE.Color(0.12151, 0.78896, 0.86581),
  new THREE.Color(0.11639, 0.7974, 0.85559),
  new THREE.Color(0.11167, 0.80569, 0.84525),
  new THREE.Color(0.10738, 0.81381, 0.83484),
  new THREE.Color(0.10357, 0.82177, 0.82437),
  new THREE.Color(0.10026, 0.82955, 0.81389),
  new THREE.Color(0.0975, 0.83714, 0.80342),
  new THREE.Color(0.09532, 0.84455, 0.79299),
  new THREE.Color(0.09377, 0.85175, 0.78264),
  new THREE.Color(0.09287, 0.85875, 0.7724),
  new THREE.Color(0.09267, 0.86554, 0.7623),
  new THREE.Color(0.0932, 0.87211, 0.75237),
  new THREE.Color(0.09451, 0.87844, 0.74265),
  new THREE.Color(0.09662, 0.88454, 0.73316),
  new THREE.Color(0.09958, 0.8904, 0.72393),
  new THREE.Color(0.10342, 0.896, 0.715),
  new THREE.Color(0.10815, 0.90142, 0.70599),
  new THREE.Color(0.11374, 0.90673, 0.69651),
  new THREE.Color(0.12014, 0.91193, 0.6866),
  new THREE.Color(0.12733, 0.91701, 0.67627),
  new THREE.Color(0.13526, 0.92197, 0.66556),
  new THREE.Color(0.14391, 0.9268, 0.65448),
  new THREE.Color(0.15323, 0.93151, 0.64308),
  new THREE.Color(0.16319, 0.93609, 0.63137),
  new THREE.Color(0.17377, 0.94053, 0.61938),
  new THREE.Color(0.18491, 0.94484, 0.60713),
  new THREE.Color(0.19659, 0.94901, 0.59466),
  new THREE.Color(0.20877, 0.95304, 0.58199),
  new THREE.Color(0.22142, 0.95692, 0.56914),
  new THREE.Color(0.23449, 0.96065, 0.55614),
  new THREE.Color(0.24797, 0.96423, 0.54303),
  new THREE.Color(0.2618, 0.96765, 0.52981),
  new THREE.Color(0.27597, 0.97092, 0.51653),
  new THREE.Color(0.29042, 0.97403, 0.50321),
  new THREE.Color(0.30513, 0.97697, 0.48987),
  new THREE.Color(0.32006, 0.97974, 0.47654),
  new THREE.Color(0.33517, 0.98234, 0.46325),
  new THREE.Color(0.35043, 0.98477, 0.45002),
  new THREE.Color(0.36581, 0.98702, 0.43688),
  new THREE.Color(0.38127, 0.98909, 0.42386),
  new THREE.Color(0.39678, 0.99098, 0.41098),
  new THREE.Color(0.41229, 0.99268, 0.39826),
  new THREE.Color(0.42778, 0.99419, 0.38575),
  new THREE.Color(0.44321, 0.99551, 0.37345),
  new THREE.Color(0.45854, 0.99663, 0.3614),
  new THREE.Color(0.47375, 0.99755, 0.34963),
  new THREE.Color(0.48879, 0.99828, 0.33816),
  new THREE.Color(0.50362, 0.99879, 0.32701),
  new THREE.Color(0.51822, 0.9991, 0.31622),
  new THREE.Color(0.53255, 0.99919, 0.30581),
  new THREE.Color(0.54658, 0.99907, 0.29581),
  new THREE.Color(0.56026, 0.99873, 0.28623),
  new THREE.Color(0.57357, 0.99817, 0.27712),
  new THREE.Color(0.58646, 0.99739, 0.26849),
  new THREE.Color(0.59891, 0.99638, 0.26038),
  new THREE.Color(0.61088, 0.99514, 0.2528),
  new THREE.Color(0.62233, 0.99366, 0.24579),
  new THREE.Color(0.63323, 0.99195, 0.23937),
  new THREE.Color(0.64362, 0.98999, 0.23356),
  new THREE.Color(0.65394, 0.98775, 0.22835),
  new THREE.Color(0.66428, 0.98524, 0.2237),
  new THREE.Color(0.67462, 0.98246, 0.2196),
  new THREE.Color(0.68494, 0.97941, 0.21602),
  new THREE.Color(0.69525, 0.9761, 0.21294),
  new THREE.Color(0.70553, 0.97255, 0.21032),
  new THREE.Color(0.71577, 0.96875, 0.20815),
  new THREE.Color(0.72596, 0.9647, 0.2064),
  new THREE.Color(0.7361, 0.96043, 0.20504),
  new THREE.Color(0.74617, 0.95593, 0.20406),
  new THREE.Color(0.75617, 0.95121, 0.20343),
  new THREE.Color(0.76608, 0.94627, 0.20311),
  new THREE.Color(0.77591, 0.94113, 0.2031),
  new THREE.Color(0.78563, 0.93579, 0.20336),
  new THREE.Color(0.79524, 0.93025, 0.20386),
  new THREE.Color(0.80473, 0.92452, 0.20459),
  new THREE.Color(0.8141, 0.91861, 0.20552),
  new THREE.Color(0.82333, 0.91253, 0.20663),
  new THREE.Color(0.83241, 0.90627, 0.20788),
  new THREE.Color(0.84133, 0.89986, 0.20926),
  new THREE.Color(0.8501, 0.89328, 0.21074),
  new THREE.Color(0.85868, 0.88655, 0.2123),
  new THREE.Color(0.86709, 0.87968, 0.21391),
  new THREE.Color(0.8753, 0.87267, 0.21555),
  new THREE.Color(0.88331, 0.86553, 0.21719),
  new THREE.Color(0.89112, 0.85826, 0.2188),
  new THREE.Color(0.8987, 0.85087, 0.22038),
  new THREE.Color(0.90605, 0.84337, 0.22188),
  new THREE.Color(0.91317, 0.83576, 0.22328),
  new THREE.Color(0.92004, 0.82806, 0.22456),
  new THREE.Color(0.92666, 0.82025, 0.2257),
  new THREE.Color(0.93301, 0.81236, 0.22667),
  new THREE.Color(0.93909, 0.80439, 0.22744),
  new THREE.Color(0.94489, 0.79634, 0.228),
  new THREE.Color(0.95039, 0.78823, 0.22831),
  new THREE.Color(0.9556, 0.78005, 0.22836),
  new THREE.Color(0.96049, 0.77181, 0.22811),
  new THREE.Color(0.96507, 0.76352, 0.22754),
  new THREE.Color(0.96931, 0.75519, 0.22663),
  new THREE.Color(0.97323, 0.74682, 0.22536),
  new THREE.Color(0.97679, 0.73842, 0.22369),
  new THREE.Color(0.98, 0.73, 0.22161),
  new THREE.Color(0.98289, 0.7214, 0.21918),
  new THREE.Color(0.98549, 0.7125, 0.2165),
  new THREE.Color(0.98781, 0.7033, 0.21358),
  new THREE.Color(0.98986, 0.69382, 0.21043),
  new THREE.Color(0.99163, 0.68408, 0.20706),
  new THREE.Color(0.99314, 0.67408, 0.20348),
  new THREE.Color(0.99438, 0.66386, 0.19971),
  new THREE.Color(0.99535, 0.65341, 0.19577),
  new THREE.Color(0.99607, 0.64277, 0.19165),
  new THREE.Color(0.99654, 0.63193, 0.18738),
  new THREE.Color(0.99675, 0.62093, 0.18297),
  new THREE.Color(0.99672, 0.60977, 0.17842),
  new THREE.Color(0.99644, 0.59846, 0.17376),
  new THREE.Color(0.99593, 0.58703, 0.16899),
  new THREE.Color(0.99517, 0.57549, 0.16412),
  new THREE.Color(0.99419, 0.56386, 0.15918),
  new THREE.Color(0.99297, 0.55214, 0.15417),
  new THREE.Color(0.99153, 0.54036, 0.1491),
  new THREE.Color(0.98987, 0.52854, 0.14398),
  new THREE.Color(0.98799, 0.51667, 0.13883),
  new THREE.Color(0.9859, 0.50479, 0.13367),
  new THREE.Color(0.9836, 0.49291, 0.12849),
  new THREE.Color(0.98108, 0.48104, 0.12332),
  new THREE.Color(0.97837, 0.4692, 0.11817),
  new THREE.Color(0.97545, 0.4574, 0.11305),
  new THREE.Color(0.97234, 0.44565, 0.10797),
  new THREE.Color(0.96904, 0.43399, 0.10294),
  new THREE.Color(0.96555, 0.42241, 0.09798),
  new THREE.Color(0.96187, 0.41093, 0.0931),
  new THREE.Color(0.95801, 0.39958, 0.08831),
  new THREE.Color(0.95398, 0.38836, 0.08362),
  new THREE.Color(0.94977, 0.37729, 0.07905),
  new THREE.Color(0.94538, 0.36638, 0.07461),
  new THREE.Color(0.94084, 0.35566, 0.07031),
  new THREE.Color(0.93612, 0.34513, 0.06616),
  new THREE.Color(0.93125, 0.33482, 0.06218),
  new THREE.Color(0.92623, 0.32473, 0.05837),
  new THREE.Color(0.92105, 0.31489, 0.05475),
  new THREE.Color(0.91572, 0.3053, 0.05134),
  new THREE.Color(0.91024, 0.29599, 0.04814),
  new THREE.Color(0.90463, 0.28696, 0.04516),
  new THREE.Color(0.89888, 0.27824, 0.04243),
  new THREE.Color(0.89298, 0.26981, 0.03993),
  new THREE.Color(0.88691, 0.26152, 0.03753),
  new THREE.Color(0.88066, 0.25334, 0.03521),
  new THREE.Color(0.87422, 0.24526, 0.03297),
  new THREE.Color(0.8676, 0.2373, 0.03082),
  new THREE.Color(0.86079, 0.22945, 0.02875),
  new THREE.Color(0.8538, 0.2217, 0.02677),
  new THREE.Color(0.84662, 0.21407, 0.02487),
  new THREE.Color(0.83926, 0.20654, 0.02305),
  new THREE.Color(0.83172, 0.19912, 0.02131),
  new THREE.Color(0.82399, 0.19182, 0.01966),
  new THREE.Color(0.81608, 0.18462, 0.01809),
  new THREE.Color(0.80799, 0.17753, 0.0166),
  new THREE.Color(0.79971, 0.17055, 0.0152),
  new THREE.Color(0.79125, 0.16368, 0.01387),
  new THREE.Color(0.7826, 0.15693, 0.01264),
  new THREE.Color(0.77377, 0.15028, 0.01148),
  new THREE.Color(0.76476, 0.14374, 0.01041),
  new THREE.Color(0.75556, 0.13731, 0.00942),
  new THREE.Color(0.74617, 0.13098, 0.00851),
  new THREE.Color(0.73661, 0.12477, 0.00769),
  new THREE.Color(0.72686, 0.11867, 0.00695),
  new THREE.Color(0.71692, 0.11268, 0.00629),
  new THREE.Color(0.7068, 0.1068, 0.00571),
  new THREE.Color(0.6965, 0.10102, 0.00522),
  new THREE.Color(0.68602, 0.09536, 0.00481),
  new THREE.Color(0.67535, 0.0898, 0.00449),
  new THREE.Color(0.66449, 0.08436, 0.00424),
  new THREE.Color(0.65345, 0.07902, 0.00408),
  new THREE.Color(0.64223, 0.0738, 0.00401),
  new THREE.Color(0.63082, 0.06868, 0.00401),
  new THREE.Color(0.61923, 0.06367, 0.0041),
  new THREE.Color(0.60746, 0.05878, 0.00427),
  new THREE.Color(0.5955, 0.05399, 0.00453),
  new THREE.Color(0.58336, 0.04931, 0.00486),
  new THREE.Color(0.57103, 0.04474, 0.00529),
  new THREE.Color(0.55852, 0.04028, 0.00579),
  new THREE.Color(0.54583, 0.03593, 0.00638),
  new THREE.Color(0.53295, 0.03169, 0.00705),
  new THREE.Color(0.51989, 0.02756, 0.0078),
  new THREE.Color(0.50664, 0.02354, 0.00863),
  new THREE.Color(0.49321, 0.01963, 0.00955),
  new THREE.Color(0.4796, 0.01583, 0.01055)
];

export default {
  components: {
    VueSlideBar
  },
  data() {
    return {
      /////// Command and vue models //////////
      remoteIp: "134.102.222.107",
      remotePort: "3000",
      hoverValue: 0,
      isHover: false,
      cmdArgs: "",
      dispOption: "med",
      benchMode: "coll",
      distAlgo: "pqp",
      loading: false,
      file: "",
      fileName: "",
      algoFile: "",
      algoFileName: "",
      algo: "simdop",
      rDeg: 60,
      aDeg: 30,
      allPolygons: "true",
      distance: 0,
      posFindingMethod: "sphere",
      gridsize: "defaultsize",
      xsize: 20,
      ysize: 20,
      zsize: 20,
      pos: "savedPos",
      posFile: "",
      posFileName: "",
      showModel: false,
      wireframeMode: false,
      filterOutliersMode: false,
      progressStatus: 4,
      longOp: false,
      benchmarkProgress: 0,
      progressInst: 0,
      progressRuntime: 0,
      //////////// Heatmap data ///////////////
      description: {},
      vertexInfo: {},
      facesInfo: {},
      verticesInfo: {},
      filteredVerticesInfo: {},
      // upperBound: {},
      // filteredUpperBound: {},
      vertTimeSummary: {
        min: 10000,
        max: 0,
        q1: 0,
        q2: 0,
        q3: 0,
        upperBound: 0
      },
      vertInstSummary: {
        min: 10000,
        max: 0,
        q1: 0,
        q2: 0,
        q3: 0,
        upperBound: 0
      },
      // verticesInfo: {},
      // filteredVerticesInfo: {},
      displaySummary: {
        min: 10000,
        max: 0,
        q1: 0,
        q2: 0,
        q3: 0,
        upperBound: 0
      },
      lowerBound: {
        timingAverage: Number.MAX_VALUE,
        timingMedian: Number.MAX_VALUE,
        timingMin: Number.MAX_VALUE,
        timingMax: Number.MAX_VALUE,
        timingSD: Number.MAX_VALUE,
        timingMeanAD: Number.MAX_VALUE,
        timingMedianAD: Number.MAX_VALUE,
        density: Number.MAX_VALUE
      },
      filteredLowerBound: {
        timingAverage: Number.MAX_VALUE,
        timingMedian: Number.MAX_VALUE,
        timingMin: Number.MAX_VALUE,
        timingMax: Number.MAX_VALUE,
        timingSD: Number.MAX_VALUE,
        timingMeanAD: Number.MAX_VALUE,
        timingMedianAD: Number.MAX_VALUE,
        density: Number.MAX_VALUE
      },
      upperBound: {
        timingAverage: 0,
        timingMedian: 0,
        timingMin: 0,
        timingMax: 0,
        timingSD: 0,
        timingMeanAD: 0,
        timingMedianAD: 0,
        density: 0
      },
      filteredUpperBound: {
        timingAverage: 0,
        timingMedian: 0,
        timingMin: 0,
        timingMax: 0,
        timingSD: 0,
        timingMeanAD: 0,
        timingMedianAD: 0,
        density: 0
      },
      filteredDensityArray: [],
      vertexTime: [],
      vertexInts: [],
      facesDensity: [],
      facesTimingAverage: [],
      facesTimingMedian: [],
      facesTimingMin: [],
      facesTimingMax: [],
      facesTimingSD: [],
      facesTimingMeanAD: [],
      facesTimingMedianAD: [],
      vertexDensity: [],
      vertexTimingAverage: [],
      vertexTimingMedian: [],
      vertexTimingMin: [],
      vertexTimingMax: [],
      vertexTimingSD: [],
      vertexTimingMedianAD: [],
      filteredVertexDensity: [],
      filteredVertexTimingAverage: [],
      filteredVertexTimingMedian: [],
      filteredVertexTimingMin: [],
      filteredVertexTimingMax: [],
      filteredVertexTimingSD: [],
      filteredVertexTimingMedianAD: [],
      /////////// 3D object data /////////////
      objectURL: "",
      heatmapVerticesURL: "",
      heatmapFacesURL: "",
      // timeResultFileURL: "",
      // intsResultFileURL: "",
      // timingAverageResultFileURL: "",
      // timingMedianResultFileURL: "",
      // timingMinResultFileURL: "",
      // timingMaxResultFileURL: "",
      // timingSDResultFileURL: "",
      // timingMeanADResultFileURL: "",
      // timingMedianADResultFileURL: "",
      // timingAverageResultFileURL: "",
      heatmapURL: "",
      densityResultFileURL: "",
      closestPointsResultFileURL: "",
      verticesInfoURL: "",
      filteredVerticesInfoURL: "",
      // filteredTimingAverageResultFileURL: "",
      // filteredTimingMedianResultFileURL: "",
      // filteredTimingMinResultFileURL: "",
      // filteredTimingMaxResultFileURL: "",
      // filteredTimingSDResultFileURL: "",
      // filteredTimingMeanADResultFileURL: "",
      // filteredTimingMedianADResultFileURL: "",
      // filteredTimingAverageResultFileURL: "",
      filteredDensityResultFileURL: "",
      // intsObj: null,
      // timeObj: null,
      heatmapObj: null,
      timingAverageObj: null,
      timingMedianObj: null,
      timingMinObj: null,
      timingMaxObj: null,
      timingSDObj: null,
      timingMeanADObj: null,
      timingMedianADObj: null,
      densityObj: null,
      filteredTimingAverageObj: null,
      filteredTimingMedianObj: null,
      filteredTimingMinObj: null,
      filteredTimingMaxObj: null,
      filteredTimingSDObj: null,
      filteredTimingMeanADObj: null,
      filteredTimingMedianADObj: null,
      filteredDensityObj: null,
      closestPointsObj: [],
      objLoader: null,
      targetList: [],
      closestPoints: [],
      mouse: { x: 0, y: 0 },
      sprite: null,
      canvas1: null,
      context1: null,
      texture1: null,
      resultLoader: null,
      parentContainer: null,
      container: null,
      textContainer: null,
      camera: null,
      scene: null,
      renderer: null,
      mouseX: 0,
      mouseY: 0,
      orbitControl: null,
      dispMode: false,
      heatmapMode: heatmapModes.TIMING.AVERAGE,
      viewClosestPoints: false,
      viewObject: true
    };
  },
  //When the component is mounted. Check the job id
  mounted() {
    //If the job id exists, ask the user to continue.
    if (localStorage.getItem("job-id")) {
      // If continue, just continue
      if (
        confirm(
          "The previous benchmark is not finished. Do you want to continue?"
        )
      ) {
        this.progressStatus = 2;
        this.fileName = localStorage.getItem("file-name");
        this.loading = true;
        this.waitServer();
      }
      // Else remove job id
      else {
        localStorage.removeItem("job-id");
        localStorage.removeItem("file-name");
      }
    }
  },
  methods: {
    checkConfig() {
      const hasAlgo = this.algo == 'custom' ? this.algoFileName.includes('.dll') : true;
      const hasPos = this.pos == 'uploadPos' ? this.posFileName.includes('.pos') : true
      return this.fileName.includes('.obj') && hasAlgo && hasPos;
    },
    //This function will be called when the start button is pressed.
    async start() {
      localStorage.setItem("file-name", this.fileName);
      this.loading = await true;
      this.showModel = await false;
      // Make an upload request to the server
      await this.sendCmd();
    },
    //This function will be called to start the command in the program on the server
    sendCmd() {
      this.progressStatus = 2;
      //If it takes longer than 20 seconds, the warning message will show up on the page.
      axios
        .post(`http://${this.remoteIp}:${this.remotePort}/cmd`, {
          objFile: {
            name: this.fileName,
            file: this.file,
          },
          mode: this.benchMode,
          algo: {
            selected: this.algo,
            custom: {
              name: this.algoFileName,
              file: this.algoFile,
            },
          },
          polygons: this.allPolygons,
          posConfig: {
            method: this.posFindingMethod,
            fileOption: this.pos,
            distAlgo: this.distAlgo,
            posFile: {
              name: this.posFileName,
              file: this.posFile,
            },
            grid: {
              gridsize: this.gridsize,
              xsize: this.xsize,
              ysize: this.ysize,
              zsize: this.zsize,
            },
            sphere: {
              rDeg: this.rDeg,
              aDeg: this.aDeg,
            },
            distance: this.distance,
          },
          dispOption: this.dispOption,
        })
        .then(async ({ data }) => {
          console.log("DATA", data);
          await localStorage.setItem("job-id", data);
          await this.waitServer();
        })
        .catch(err => {
          alert(err);
          this.showModel = false;
          this.loading = false;
        });
    },
    // Send job id to check to benchmark progress every 2 seconds
    waitServer() {
      let checkCounter = 0;
      const currentJobId = localStorage.getItem("job-id");
      console.log(currentJobId);
      let waiting = setInterval(() => {
        if (checkCounter > 20) {
          this.longOp = true;
          this.progressStatus = 3;
        }
        axios
          .post(`http://${this.remoteIp}:${this.remotePort}/checkProgress`, {
            jobId: currentJobId
          })
          .then(async ({ data }) => {
            if (!data.id) {
              this.progressStatus = 4;
              this.benchmarkProgress = 100;
              // console.log(data);
              //Get the data.data from the respose message
              this.objectScale = await data.data.objScale;
              this.description = await data.data.description;

              //Get object URLs from the server
              // console.log("here3");
              await this.setResultsURL();
              this.progressStatus = 5;
              await setTimeout(async () => {
                this.showModel = await true;
                this.loading = await false;
                //Start to render the heatmap
                await this.showHeatMap();
                await localStorage.removeItem("job-id");
                localStorage.removeItem("file-name");
                await clearInterval(waiting);
              }, 1000);
            } else {
              checkCounter++;
              if (data.progress != -1) this.benchmarkProgress = data.progress;
              else {
                await alert(
                  "Benchmark error, plase contact server maintainer."
                );
                await clearInterval(waiting);
                await localStorage.removeItem("job-id");
                localStorage.removeItem("file-name");
                this.loading = await false;
                this.clearRemoteFile();
              }
            }
          })
          .catch(err => {
            clearInterval(waiting);
          });
      }, 2000);
    },
    //This function will be used when the client request the 3d object to show on the page.
    async setResultsURL() {
      this.objectURL = `http://${this.remoteIp}:${this.remotePort}/${
        this.fileName.split(".")[0]
      }.obj`;
      this.heatmapURL = `http://${this.remoteIp}:${this.remotePort}/${
        this.fileName.split(".")[0]
      }.heatmap`;
      this.heatmapVerticesURL = `http://${this.remoteIp}:${this.remotePort}/${
        this.fileName.split(".")[0]
      }.heatmapVertices`;
      this.heatmapFacesURL = `http://${this.remoteIp}:${this.remotePort}/${
        this.fileName.split(".")[0]
      }.heatmapFaces`;
      this.closestPointsResultFileURL = `http://${this.remoteIp}:${
        this.remotePort
      }/${this.fileName.split(".")[0]}.closestPoints`;
      this.verticesInfoURL = `http://${this.remoteIp}:${this.remotePort}/${
        this.fileName.split(".")[0]
      }.verticesInfo`;
      this.filteredVerticesInfoURL = `http://${this.remoteIp}:${
        this.remotePort
      }/${this.fileName.split(".")[0]}.filteredVerticesInfo`;
    },

    applyAverageColor() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingAverage(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingAverage,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingAverage(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingAverage,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingAverage(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingAverage,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyAverageColorFiltered() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingAverage(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingAverage,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingAverage(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingAverage,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingAverage(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingAverage,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyMedianColor() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingMedian(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingMedian,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingMedian(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingMedian,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingMedian(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingMedian,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
      //console.log(this.heatmapObj);
    },

    applyMedianColorFiltered() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingMedian(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingMedian,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingMedian(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingMedian,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingMedian(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingMedian,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyMinColor() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingMin(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingMin,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingMin(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingMin,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingMin(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingMin,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyMinColorFiltered() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingMin(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingMin,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingMin(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingMin,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingMin(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingMin,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyMaxColor() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingMax(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingMax,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingMax(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingMax,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingMax(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingMax,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyMaxColorFiltered() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingMax(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingMax,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingMax(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingMax,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingMax(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingMax,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },
    applySDColor() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingSD(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].a].vertexTimingSD,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingSD(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].b].vertexTimingSD,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingSD(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].c].vertexTimingSD,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applySDColorFiltered() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingSD(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingSD,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingSD(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingSD,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingSD(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingSD,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyMedianADColor() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingMedianAD(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingMedianAD,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingMedianAD(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingMedianAD,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingMedianAD(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingMedianAD,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyMedianADColorFiltered() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorTimingMedianAD(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].a]
            .vertexTimingMedianAD,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorTimingMedianAD(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].b]
            .vertexTimingMedianAD,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorTimingMedianAD(
          this.filteredVerticesInfo[this.heatmapObj.geometry.faces[i].c]
            .vertexTimingMedianAD,
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyDensityColor() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorDensity(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].a].vertexDensity,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorDensity(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].b].vertexDensity,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorDensity(
          this.verticesInfo[this.heatmapObj.geometry.faces[i].c].vertexDensity,
          turbo_srgb_colors,
          this.upperBound,
          this.lowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    applyDensityColorFiltered() {
      if (!this.verticesMatch()) {
        console.log(
          "vertices missmatch (verticesInfo - heatmapObj)",
          this.verticesInfo.length,
          this.heatmapObj.geometry.vertices.length
        );
      }
      for (let i = 0; i < this.heatmapObj.geometry.faces.length; i++) {
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[0] = this.estColorDensity(
          this.filteredDensityArray[this.heatmapObj.geometry.faces[i].a],
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[1] = this.estColorDensity(
          this.filteredDensityArray[this.heatmapObj.geometry.faces[i].b],
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
        this.heatmapObj.geometry.faces[
          i
        ].vertexColors[2] = this.estColorDensity(
          this.filteredDensityArray[this.heatmapObj.geometry.faces[i].c],
          turbo_srgb_colors,
          this.filteredUpperBound,
          this.filteredLowerBound
        );
      }
      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },

    verticesMatch() {
      return (
        this.verticesInfo.length == this.heatmapObj.geometry.vertices.length
      );
    },

    estColorTimingAverage(data, turbo_srgb_colors, upperBound, lowerBound) {
      if (data > 0) {
        // from https://stackoverflow.com/questions/929103/convert-a-number-range-to-another-range-maintaining-ratio
        //NewValue = (((OldValue - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin)) + NewMin
        let color = Math.floor(
          ((data - lowerBound.timingAverage) * 255) /
            (upperBound.timingAverage - lowerBound.timingAverage)
        );
        if (color > 255) {
          console.log("color out of range = ", color);
        }
        return turbo_srgb_colors[color];
      } else {
        return new THREE.Color("rgb(211, 211, 211)");
      }
    },

    estColorTimingMedian(data, turbo_srgb_colors, upperBound, lowerBound) {
      if (data > 0) {
        let color = Math.floor(
          ((data - lowerBound.timingMedian) * 255) /
            (upperBound.timingMedian - lowerBound.timingMedian)
        );
        if (color > 255) {
          console.log("color out of range = ", color);
        }
        return turbo_srgb_colors[color];
      } else {
        return new THREE.Color("rgb(211, 211, 211)");
      }
    },

    estColorTimingMin(data, turbo_srgb_colors, upperBound, lowerBound) {
      if (data > 0) {
        let color = Math.floor(
          ((data - lowerBound.timingMin) * 255) /
            (upperBound.timingMin - lowerBound.timingMin)
        );
        if (color > 255) {
          console.log("color out of range = ", color);
        }
        return turbo_srgb_colors[color];
      } else {
        return new THREE.Color("rgb(211, 211, 211)");
      }
    },

    estColorTimingMax(data, turbo_srgb_colors, upperBound, lowerBound) {
      if (data > 0) {
        let color = Math.floor(
          ((data - lowerBound.timingMax) * 255) /
            (upperBound.timingMax - lowerBound.timingMax)
        );
        if (color > 255) {
          console.log("color out of range = ", color);
        }
        return turbo_srgb_colors[color];
      } else {
        return new THREE.Color("rgb(211, 211, 211)");
      }
    },

    estColorTimingSD(data, turbo_srgb_colors, upperBound, lowerBound) {
      if (data > 0) {
        let color = Math.floor(
          ((data - lowerBound.timingSD) * 255) /
            (upperBound.timingSD - lowerBound.timingSD)
        );
        if (color > 255) {
          console.log("color out of range = ", color);
        }
        return turbo_srgb_colors[color];
      } else {
        return new THREE.Color("rgb(211, 211, 211)");
      }
    },
    estColorTimingMedianAD(data, turbo_srgb_colors, upperBound, lowerBound) {
      if (data > 0) {
        let color = Math.floor(
          ((data - lowerBound.timingMedianAD) * 255) /
            (upperBound.timingMedianAD - lowerBound.timingMedianAD)
        );
        if (color > 255) {
          console.log("color out of range = ", color);
        }
        return turbo_srgb_colors[color];
      } else {
        return new THREE.Color("rgb(211, 211, 211)");
      }
    },

    estColorDensity(data, turbo_srgb_colors, upperBound, lowerBound) {
      if (data > 0) {
        let color = Math.floor(
          ((data - lowerBound.density) * 255) /
            (upperBound.density - lowerBound.density)
        );
        if (color > 255) {
          console.log("color out of range = ", color);
        }
        return turbo_srgb_colors[color];
      } else {
        return new THREE.Color("rgb(211, 211, 211)");
      }
    },

    // A Javascript function to filter an array of values for outliers by using an interquartile filter
    // https://gist.github.com/ogun/f19dc055e6b84d57e8186cbc9eaa8e45#file-outliersfilter-js-L1
    filterOutliers(data) {
      if (data.length < 4) return data;

      let values, q1, q3, iqr, maxValue, minValue;

      values = data.slice().sort((a, b) => a - b); //copy array fast and sort

      if ((values.length / 4) % 1 === 0) {
        //find quartiles
        q1 =
          (1 / 2) * (values[values.length / 4] + values[values.length / 4 + 1]);
        q3 =
          (1 / 2) *
          (values[values.length * (3 / 4)] +
            values[values.length * (3 / 4) + 1]);
      } else {
        q1 = values[Math.floor(values.length / 4 + 1)];
        q3 = values[Math.ceil(values.length * (3 / 4) + 1)];
      }

      iqr = q3 - q1;
      maxValue = q3 + iqr * 1.5;
      minValue = q1 - iqr * 1.5;

      let minOutlierCount = 0;
      let maxOutlierCount = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i] > maxValue) {
          data[i] = maxValue;
          maxOutlierCount++;
        }
        if (data[i] < minValue) {
          data[i] = minValue;
          minOutlierCount++;
        }
      }

      console.log("outlier count = ", minOutlierCount, maxOutlierCount);
      //console.log(data);
      return data;
      //return values.filter((x) => x >= minValue && x <= maxValue);
    },

    async initColorMap(min, max) {
      // google turbo colormap
      // from https://gist.githubusercontent.com/mikhailov-work/6a308c20e494d9e0ccc29036b28faa7a/raw/a438da918f140eac8775be5e302f63795d9e28c3/turbo_colormap.c
      var turbo_srgb = [
        [0.18995, 0.07176, 0.23217],
        [0.19483, 0.08339, 0.26149],
        [0.19956, 0.09498, 0.29024],
        [0.20415, 0.10652, 0.31844],
        [0.2086, 0.11802, 0.34607],
        [0.21291, 0.12947, 0.37314],
        [0.21708, 0.14087, 0.39964],
        [0.22111, 0.15223, 0.42558],
        [0.225, 0.16354, 0.45096],
        [0.22875, 0.17481, 0.47578],
        [0.23236, 0.18603, 0.50004],
        [0.23582, 0.1972, 0.52373],
        [0.23915, 0.20833, 0.54686],
        [0.24234, 0.21941, 0.56942],
        [0.24539, 0.23044, 0.59142],
        [0.2483, 0.24143, 0.61286],
        [0.25107, 0.25237, 0.63374],
        [0.25369, 0.26327, 0.65406],
        [0.25618, 0.27412, 0.67381],
        [0.25853, 0.28492, 0.693],
        [0.26074, 0.29568, 0.71162],
        [0.2628, 0.30639, 0.72968],
        [0.26473, 0.31706, 0.74718],
        [0.26652, 0.32768, 0.76412],
        [0.26816, 0.33825, 0.7805],
        [0.26967, 0.34878, 0.79631],
        [0.27103, 0.35926, 0.81156],
        [0.27226, 0.3697, 0.82624],
        [0.27334, 0.38008, 0.84037],
        [0.27429, 0.39043, 0.85393],
        [0.27509, 0.40072, 0.86692],
        [0.27576, 0.41097, 0.87936],
        [0.27628, 0.42118, 0.89123],
        [0.27667, 0.43134, 0.90254],
        [0.27691, 0.44145, 0.91328],
        [0.27701, 0.45152, 0.92347],
        [0.27698, 0.46153, 0.93309],
        [0.2768, 0.47151, 0.94214],
        [0.27648, 0.48144, 0.95064],
        [0.27603, 0.49132, 0.95857],
        [0.27543, 0.50115, 0.96594],
        [0.27469, 0.51094, 0.97275],
        [0.27381, 0.52069, 0.97899],
        [0.27273, 0.5304, 0.98461],
        [0.27106, 0.54015, 0.9893],
        [0.26878, 0.54995, 0.99303],
        [0.26592, 0.55979, 0.99583],
        [0.26252, 0.56967, 0.99773],
        [0.25862, 0.57958, 0.99876],
        [0.25425, 0.5895, 0.99896],
        [0.24946, 0.59943, 0.99835],
        [0.24427, 0.60937, 0.99697],
        [0.23874, 0.61931, 0.99485],
        [0.23288, 0.62923, 0.99202],
        [0.22676, 0.63913, 0.98851],
        [0.22039, 0.64901, 0.98436],
        [0.21382, 0.65886, 0.97959],
        [0.20708, 0.66866, 0.97423],
        [0.20021, 0.67842, 0.96833],
        [0.19326, 0.68812, 0.9619],
        [0.18625, 0.69775, 0.95498],
        [0.17923, 0.70732, 0.94761],
        [0.17223, 0.7168, 0.93981],
        [0.16529, 0.7262, 0.93161],
        [0.15844, 0.73551, 0.92305],
        [0.15173, 0.74472, 0.91416],
        [0.14519, 0.75381, 0.90496],
        [0.13886, 0.76279, 0.8955],
        [0.13278, 0.77165, 0.8858],
        [0.12698, 0.78037, 0.8759],
        [0.12151, 0.78896, 0.86581],
        [0.11639, 0.7974, 0.85559],
        [0.11167, 0.80569, 0.84525],
        [0.10738, 0.81381, 0.83484],
        [0.10357, 0.82177, 0.82437],
        [0.10026, 0.82955, 0.81389],
        [0.0975, 0.83714, 0.80342],
        [0.09532, 0.84455, 0.79299],
        [0.09377, 0.85175, 0.78264],
        [0.09287, 0.85875, 0.7724],
        [0.09267, 0.86554, 0.7623],
        [0.0932, 0.87211, 0.75237],
        [0.09451, 0.87844, 0.74265],
        [0.09662, 0.88454, 0.73316],
        [0.09958, 0.8904, 0.72393],
        [0.10342, 0.896, 0.715],
        [0.10815, 0.90142, 0.70599],
        [0.11374, 0.90673, 0.69651],
        [0.12014, 0.91193, 0.6866],
        [0.12733, 0.91701, 0.67627],
        [0.13526, 0.92197, 0.66556],
        [0.14391, 0.9268, 0.65448],
        [0.15323, 0.93151, 0.64308],
        [0.16319, 0.93609, 0.63137],
        [0.17377, 0.94053, 0.61938],
        [0.18491, 0.94484, 0.60713],
        [0.19659, 0.94901, 0.59466],
        [0.20877, 0.95304, 0.58199],
        [0.22142, 0.95692, 0.56914],
        [0.23449, 0.96065, 0.55614],
        [0.24797, 0.96423, 0.54303],
        [0.2618, 0.96765, 0.52981],
        [0.27597, 0.97092, 0.51653],
        [0.29042, 0.97403, 0.50321],
        [0.30513, 0.97697, 0.48987],
        [0.32006, 0.97974, 0.47654],
        [0.33517, 0.98234, 0.46325],
        [0.35043, 0.98477, 0.45002],
        [0.36581, 0.98702, 0.43688],
        [0.38127, 0.98909, 0.42386],
        [0.39678, 0.99098, 0.41098],
        [0.41229, 0.99268, 0.39826],
        [0.42778, 0.99419, 0.38575],
        [0.44321, 0.99551, 0.37345],
        [0.45854, 0.99663, 0.3614],
        [0.47375, 0.99755, 0.34963],
        [0.48879, 0.99828, 0.33816],
        [0.50362, 0.99879, 0.32701],
        [0.51822, 0.9991, 0.31622],
        [0.53255, 0.99919, 0.30581],
        [0.54658, 0.99907, 0.29581],
        [0.56026, 0.99873, 0.28623],
        [0.57357, 0.99817, 0.27712],
        [0.58646, 0.99739, 0.26849],
        [0.59891, 0.99638, 0.26038],
        [0.61088, 0.99514, 0.2528],
        [0.62233, 0.99366, 0.24579],
        [0.63323, 0.99195, 0.23937],
        [0.64362, 0.98999, 0.23356],
        [0.65394, 0.98775, 0.22835],
        [0.66428, 0.98524, 0.2237],
        [0.67462, 0.98246, 0.2196],
        [0.68494, 0.97941, 0.21602],
        [0.69525, 0.9761, 0.21294],
        [0.70553, 0.97255, 0.21032],
        [0.71577, 0.96875, 0.20815],
        [0.72596, 0.9647, 0.2064],
        [0.7361, 0.96043, 0.20504],
        [0.74617, 0.95593, 0.20406],
        [0.75617, 0.95121, 0.20343],
        [0.76608, 0.94627, 0.20311],
        [0.77591, 0.94113, 0.2031],
        [0.78563, 0.93579, 0.20336],
        [0.79524, 0.93025, 0.20386],
        [0.80473, 0.92452, 0.20459],
        [0.8141, 0.91861, 0.20552],
        [0.82333, 0.91253, 0.20663],
        [0.83241, 0.90627, 0.20788],
        [0.84133, 0.89986, 0.20926],
        [0.8501, 0.89328, 0.21074],
        [0.85868, 0.88655, 0.2123],
        [0.86709, 0.87968, 0.21391],
        [0.8753, 0.87267, 0.21555],
        [0.88331, 0.86553, 0.21719],
        [0.89112, 0.85826, 0.2188],
        [0.8987, 0.85087, 0.22038],
        [0.90605, 0.84337, 0.22188],
        [0.91317, 0.83576, 0.22328],
        [0.92004, 0.82806, 0.22456],
        [0.92666, 0.82025, 0.2257],
        [0.93301, 0.81236, 0.22667],
        [0.93909, 0.80439, 0.22744],
        [0.94489, 0.79634, 0.228],
        [0.95039, 0.78823, 0.22831],
        [0.9556, 0.78005, 0.22836],
        [0.96049, 0.77181, 0.22811],
        [0.96507, 0.76352, 0.22754],
        [0.96931, 0.75519, 0.22663],
        [0.97323, 0.74682, 0.22536],
        [0.97679, 0.73842, 0.22369],
        [0.98, 0.73, 0.22161],
        [0.98289, 0.7214, 0.21918],
        [0.98549, 0.7125, 0.2165],
        [0.98781, 0.7033, 0.21358],
        [0.98986, 0.69382, 0.21043],
        [0.99163, 0.68408, 0.20706],
        [0.99314, 0.67408, 0.20348],
        [0.99438, 0.66386, 0.19971],
        [0.99535, 0.65341, 0.19577],
        [0.99607, 0.64277, 0.19165],
        [0.99654, 0.63193, 0.18738],
        [0.99675, 0.62093, 0.18297],
        [0.99672, 0.60977, 0.17842],
        [0.99644, 0.59846, 0.17376],
        [0.99593, 0.58703, 0.16899],
        [0.99517, 0.57549, 0.16412],
        [0.99419, 0.56386, 0.15918],
        [0.99297, 0.55214, 0.15417],
        [0.99153, 0.54036, 0.1491],
        [0.98987, 0.52854, 0.14398],
        [0.98799, 0.51667, 0.13883],
        [0.9859, 0.50479, 0.13367],
        [0.9836, 0.49291, 0.12849],
        [0.98108, 0.48104, 0.12332],
        [0.97837, 0.4692, 0.11817],
        [0.97545, 0.4574, 0.11305],
        [0.97234, 0.44565, 0.10797],
        [0.96904, 0.43399, 0.10294],
        [0.96555, 0.42241, 0.09798],
        [0.96187, 0.41093, 0.0931],
        [0.95801, 0.39958, 0.08831],
        [0.95398, 0.38836, 0.08362],
        [0.94977, 0.37729, 0.07905],
        [0.94538, 0.36638, 0.07461],
        [0.94084, 0.35566, 0.07031],
        [0.93612, 0.34513, 0.06616],
        [0.93125, 0.33482, 0.06218],
        [0.92623, 0.32473, 0.05837],
        [0.92105, 0.31489, 0.05475],
        [0.91572, 0.3053, 0.05134],
        [0.91024, 0.29599, 0.04814],
        [0.90463, 0.28696, 0.04516],
        [0.89888, 0.27824, 0.04243],
        [0.89298, 0.26981, 0.03993],
        [0.88691, 0.26152, 0.03753],
        [0.88066, 0.25334, 0.03521],
        [0.87422, 0.24526, 0.03297],
        [0.8676, 0.2373, 0.03082],
        [0.86079, 0.22945, 0.02875],
        [0.8538, 0.2217, 0.02677],
        [0.84662, 0.21407, 0.02487],
        [0.83926, 0.20654, 0.02305],
        [0.83172, 0.19912, 0.02131],
        [0.82399, 0.19182, 0.01966],
        [0.81608, 0.18462, 0.01809],
        [0.80799, 0.17753, 0.0166],
        [0.79971, 0.17055, 0.0152],
        [0.79125, 0.16368, 0.01387],
        [0.7826, 0.15693, 0.01264],
        [0.77377, 0.15028, 0.01148],
        [0.76476, 0.14374, 0.01041],
        [0.75556, 0.13731, 0.00942],
        [0.74617, 0.13098, 0.00851],
        [0.73661, 0.12477, 0.00769],
        [0.72686, 0.11867, 0.00695],
        [0.71692, 0.11268, 0.00629],
        [0.7068, 0.1068, 0.00571],
        [0.6965, 0.10102, 0.00522],
        [0.68602, 0.09536, 0.00481],
        [0.67535, 0.0898, 0.00449],
        [0.66449, 0.08436, 0.00424],
        [0.65345, 0.07902, 0.00408],
        [0.64223, 0.0738, 0.00401],
        [0.63082, 0.06868, 0.00401],
        [0.61923, 0.06367, 0.0041],
        [0.60746, 0.05878, 0.00427],
        [0.5955, 0.05399, 0.00453],
        [0.58336, 0.04931, 0.00486],
        [0.57103, 0.04474, 0.00529],
        [0.55852, 0.04028, 0.00579],
        [0.54583, 0.03593, 0.00638],
        [0.53295, 0.03169, 0.00705],
        [0.51989, 0.02756, 0.0078],
        [0.50664, 0.02354, 0.00863],
        [0.49321, 0.01963, 0.00955],
        [0.4796, 0.01583, 0.01055]
      ];

      let cv = document.getElementById("colorMap"),
        ctx = cv.getContext("2d");
      // clear the canvas before draw
      ctx.clearRect(0, 0, cv.width, cv.height);

      for (let i = 0; i < turbo_srgb.length; i++) {
        ctx.beginPath();

        let singleColor =
          "rgb(" +
          turbo_srgb[turbo_srgb.length - 1 - i][0] * 255 +
          "," +
          turbo_srgb[turbo_srgb.length - 1 - i][1] * 255 +
          ", " +
          turbo_srgb[turbo_srgb.length - 1 - i][2] * 255 +
          ")";
        ctx.fillStyle = singleColor;

        ctx.fillRect(0, i * 2, 50, 512);
      }

      if (max > 0) {
        ctx.font = "20px Arial";
        ctx.fillStyle = "rgb(31, 255, 255)";
        ctx.textAlign = "center";
        ctx.fillText(min, cv.width / 2, cv.height / 1.02);
        ctx.fillText(max, cv.width / 2, cv.height / 25);
      }
    },

    async loadResults() {
      const responseVerticesInfo = await axios.get(this.verticesInfoURL);
      this.verticesInfo = responseVerticesInfo.data;

      // calculate upperBound
      for (let i = 0; i < this.verticesInfo.length; i++) {
        if (this.verticesInfo[i].vertexDensity > 1) {
          if (
            this.verticesInfo[i].vertexTimingAverage >
            this.upperBound.timingAverage
          ) {
            this.upperBound.timingAverage = this.verticesInfo[
              i
            ].vertexTimingAverage;
          }
          if (
            this.verticesInfo[i].vertexTimingMedian >
            this.upperBound.timingMedian
          ) {
            this.upperBound.timingMedian = this.verticesInfo[
              i
            ].vertexTimingMedian;
          }
          if (
            this.verticesInfo[i].vertexTimingMin > this.upperBound.timingMin
          ) {
            this.upperBound.timingMin = this.verticesInfo[i].vertexTimingMin;
          }
          if (
            this.verticesInfo[i].vertexTimingMax > this.upperBound.timingMax
          ) {
            this.upperBound.timingMax = this.verticesInfo[i].vertexTimingMax;
          }
          if (this.verticesInfo[i].vertexTimingSD > this.upperBound.timingSD) {
            this.upperBound.timingSD = this.verticesInfo[i].vertexTimingSD;
          }
          if (
            this.verticesInfo[i].vertexTimingMedianAD >
            this.upperBound.timingMedianAD
          ) {
            this.upperBound.timingMedianAD = this.verticesInfo[
              i
            ].vertexTimingMedianAD;
          }
          if (this.verticesInfo[i].vertexDensity > this.upperBound.density) {
            this.upperBound.density = this.verticesInfo[i].vertexDensity;
          }
        } else if (this.verticesInfo[i].vertexDensity == 1) {
          if (this.verticesInfo[i].vertexDensity > this.upperBound.density) {
            this.upperBound.density = this.verticesInfo[i].vertexDensity;
          }
          if (
            this.verticesInfo[i].vertexTimingAverage >
            this.upperBound.timingAverage
          ) {
            this.upperBound.timingAverage = this.verticesInfo[
              i
            ].vertexTimingAverage;
          }
          if (
            this.verticesInfo[i].vertexTimingMedian >
            this.upperBound.timingMedian
          ) {
            this.upperBound.timingMedian = this.verticesInfo[
              i
            ].vertexTimingMedian;
          }
          if (
            this.verticesInfo[i].vertexTimingMin > this.upperBound.timingMin
          ) {
            this.upperBound.timingMin = this.verticesInfo[i].vertexTimingMin;
          }
          if (
            this.verticesInfo[i].vertexTimingMax > this.upperBound.timingMax
          ) {
            this.upperBound.timingMax = this.verticesInfo[i].vertexTimingMax;
          }
        }
      }

      // calculate lowerBound
      for (let i = 0; i < this.verticesInfo.length; i++) {
        if (this.verticesInfo[i].vertexDensity > 1) {
          if (
            this.verticesInfo[i].vertexTimingAverage <
            this.lowerBound.timingAverage
          ) {
            this.lowerBound.timingAverage = this.verticesInfo[
              i
            ].vertexTimingAverage;
          }
          if (
            this.verticesInfo[i].vertexTimingMedian <
            this.lowerBound.timingMedian
          ) {
            this.lowerBound.timingMedian = this.verticesInfo[
              i
            ].vertexTimingMedian;
          }
          if (
            this.verticesInfo[i].vertexTimingMin < this.lowerBound.timingMin
          ) {
            this.lowerBound.timingMin = this.verticesInfo[i].vertexTimingMin;
          }
          if (
            this.verticesInfo[i].vertexTimingMax < this.lowerBound.timingMax
          ) {
            this.lowerBound.timingMax = this.verticesInfo[i].vertexTimingMax;
          }
          if (this.verticesInfo[i].vertexTimingSD < this.lowerBound.timingSD) {
            this.lowerBound.timingSD = this.verticesInfo[i].vertexTimingSD;
          }
          if (
            this.verticesInfo[i].vertexTimingMedianAD <
            this.lowerBound.timingMedianAD
          ) {
            this.lowerBound.timingMedianAD = this.verticesInfo[
              i
            ].vertexTimingMedianAD;
          }
          if (this.verticesInfo[i].vertexDensity < this.lowerBound.density) {
            this.lowerBound.density = this.verticesInfo[i].vertexDensity;
          }
        } else if (this.verticesInfo[i].vertexDensity == 1) {
          if (this.verticesInfo[i].vertexDensity < this.lowerBound.density) {
            this.lowerBound.density = this.verticesInfo[i].vertexDensity;
          }
          if (
            this.verticesInfo[i].vertexTimingAverage <
            this.lowerBound.timingAverage
          ) {
            this.lowerBound.timingAverage = this.verticesInfo[
              i
            ].vertexTimingAverage;
          }
          if (
            this.verticesInfo[i].vertexTimingMedian <
            this.lowerBound.timingMedian
          ) {
            this.lowerBound.timingMedian = this.verticesInfo[
              i
            ].vertexTimingMedian;
          }
          if (
            this.verticesInfo[i].vertexTimingMin < this.lowerBound.timingMin
          ) {
            this.lowerBound.timingMin = this.verticesInfo[i].vertexTimingMin;
          }
          if (
            this.verticesInfo[i].vertexTimingMax < this.lowerBound.timingMax
          ) {
            this.lowerBound.timingMax = this.verticesInfo[i].vertexTimingMax;
          }
        }
      }

      const responseFilteredVerticesInfo = await axios.get(
        this.filteredVerticesInfoURL
      );
      this.filteredVerticesInfo = responseFilteredVerticesInfo.data;

      let densityArray = [];
      for (let i = 0; i < this.filteredVerticesInfo.length; i++) {
        densityArray.push(this.filteredVerticesInfo[i].vertexDensity);
      }
      // console.log("densityArray = ", densityArray);

      this.filteredDensityArray = this.filterOutliers(densityArray);

      // console.log("filteredDensityArray = ", this.filteredDensityArray);

      for (let i = 0; i < this.filteredDensityArray.length; i++) {
        if (this.filteredDensityArray[i] > this.filteredUpperBound.density) {
          this.filteredUpperBound.density = this.filteredDensityArray[i];
        }

        if (this.filteredDensityArray[i] < this.filteredLowerBound.density) {
          this.filteredLowerBound.density = this.filteredDensityArray[i];
        }
      }

      // console.log("filteredUpperBound = ", this.filteredUpperBound);
      // console.log("filteredLowerBound = ", this.filteredLowerBound);

      for (let i = 0; i < this.filteredVerticesInfo.length; i++) {
        if (this.filteredVerticesInfo[i].vertexDensity > 1) {
          if (
            this.filteredVerticesInfo[i].vertexTimingAverage >
            this.filteredUpperBound.timingAverage
          ) {
            this.filteredUpperBound.timingAverage = this.filteredVerticesInfo[
              i
            ].vertexTimingAverage;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMedian >
            this.filteredUpperBound.timingMedian
          ) {
            this.filteredUpperBound.timingMedian = this.filteredVerticesInfo[
              i
            ].vertexTimingMedian;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMin >
            this.filteredUpperBound.timingMin
          ) {
            this.filteredUpperBound.timingMin = this.filteredVerticesInfo[
              i
            ].vertexTimingMin;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMax >
            this.filteredUpperBound.timingMax
          ) {
            this.filteredUpperBound.timingMax = this.filteredVerticesInfo[
              i
            ].vertexTimingMax;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingSD >
            this.filteredUpperBound.timingSD
          ) {
            this.filteredUpperBound.timingSD = this.filteredVerticesInfo[
              i
            ].vertexTimingSD;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMedianAD >
            this.filteredUpperBound.timingMedianAD
          ) {
            this.filteredUpperBound.timingMedianAD = this.filteredVerticesInfo[
              i
            ].vertexTimingMedianAD;
          }
        } else if (this.filteredVerticesInfo[i].vertexDensity == 1) {
          if (
            this.filteredVerticesInfo[i].vertexTimingAverage >
            this.filteredUpperBound.timingAverage
          ) {
            this.filteredUpperBound.timingAverage = this.filteredVerticesInfo[
              i
            ].vertexTimingAverage;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMedian >
            this.filteredUpperBound.timingMedian
          ) {
            this.filteredUpperBound.timingMedian = this.filteredVerticesInfo[
              i
            ].vertexTimingMedian;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMin >
            this.filteredUpperBound.timingMin
          ) {
            this.filteredUpperBound.timingMin = this.filteredVerticesInfo[
              i
            ].vertexTimingMin;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMax >
            this.filteredUpperBound.timingMax
          ) {
            this.filteredUpperBound.timingMax = this.filteredVerticesInfo[
              i
            ].vertexTimingMax;
          }
        }
      }

      for (let i = 0; i < this.filteredVerticesInfo.length; i++) {
        if (this.filteredVerticesInfo[i].vertexDensity > 1) {
          if (
            this.filteredVerticesInfo[i].vertexTimingAverage <
            this.filteredLowerBound.timingAverage
          ) {
            this.filteredLowerBound.timingAverage = this.filteredVerticesInfo[
              i
            ].vertexTimingAverage;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMedian <
            this.filteredLowerBound.timingMedian
          ) {
            this.filteredLowerBound.timingMedian = this.filteredVerticesInfo[
              i
            ].vertexTimingMedian;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMin <
            this.filteredLowerBound.timingMin
          ) {
            this.filteredLowerBound.timingMin = this.filteredVerticesInfo[
              i
            ].vertexTimingMin;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMax <
            this.filteredLowerBound.timingMax
          ) {
            this.filteredLowerBound.timingMax = this.filteredVerticesInfo[
              i
            ].vertexTimingMax;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingSD <
            this.filteredLowerBound.timingSD
          ) {
            this.filteredLowerBound.timingSD = this.filteredVerticesInfo[
              i
            ].vertexTimingSD;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMedianAD <
            this.filteredLowerBound.timingMedianAD
          ) {
            this.filteredLowerBound.timingMedianAD = this.filteredVerticesInfo[
              i
            ].vertexTimingMedianAD;
          }
        } else if (this.filteredVerticesInfo[i].vertexDensity == 1) {
          if (
            this.filteredVerticesInfo[i].vertexTimingAverage >
            this.filteredLowerBound.timingAverage
          ) {
            this.filteredLowerBound.timingAverage = this.filteredVerticesInfo[
              i
            ].vertexTimingAverage;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMedian <
            this.filteredLowerBound.timingMedian
          ) {
            this.filteredLowerBound.timingMedian = this.filteredVerticesInfo[
              i
            ].vertexTimingMedian;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMin <
            this.filteredLowerBound.timingMin
          ) {
            this.filteredLowerBound.timingMin = this.filteredVerticesInfo[
              i
            ].vertexTimingMin;
          }
          if (
            this.filteredVerticesInfo[i].vertexTimingMax <
            this.filteredLowerBound.timingMax
          ) {
            this.filteredLowerBound.timingMax = this.filteredVerticesInfo[
              i
            ].vertexTimingMax;
          }
        }
      }
       this.filteredUpperBound.timingMedian = 0.82;
       this.filteredUpperBound.timingMedian = 0.01;
    },
    // Want to use async/await? Add the `async` keyword to your outer function/method.
    async initClosestPoints() {
      try {
        //console.log(this.closestPointsResultFileURL);
        //let closestPoints = [];
        const responseClosestPoints = await axios.get(
          this.closestPointsResultFileURL
        );
        this.closestPoints = responseClosestPoints.data;
        // console.log("responseClosestPoints.data length = ", responseClosestPoints.data.length);
        //console.log(this.closestPoints);
        //var tempArray = response.data.split("\n");
        // console.log(tempArray);
        // TODO: find a better way to parse result.
        // for (var i = 0; i < tempArray.length - 1; i++) {
        //   var singlePointStr = tempArray[i].split(",");

        //   var closestPoint = [
        //     parseFloat(singlePointStr[0]),
        //     parseFloat(singlePointStr[1]),
        //     parseFloat(singlePointStr[2])
        //   ];
        //   //console.log(closestPoint);
        //   this.closestPoints.push(closestPoint);
        // }

        // console.log("closestPoints length = ", this.closestPoints.length);
        // init instanced mesh for closest points
        // var mesh = null;
        var dummy = new THREE.Object3D();
        // console.log("closestPoints length = ", this.closestPoints.length);
        this.closestPointsObj = new THREE.InstancedMesh(
          await new THREE.BoxBufferGeometry(0.002, 0.002, 0.002),
          new THREE.MeshBasicMaterial({ color: 0xfc0303 }),
          this.closestPoints.length
        );
        //console.log("mesh count = ", this.closestPointsObj.count);
        //console.log(mesh);

        for (var i = 0; i < this.closestPointsObj.count; i++) {
          await dummy.position.set(
            this.closestPoints[i][0],
            this.closestPoints[i][1],
            this.closestPoints[i][2]
          );
          await dummy.updateMatrix();
          //console.log(dummy.matrix);
          await this.closestPointsObj.setMatrixAt(i, dummy.matrix);
        }

        this.closestPointsObj.instanceMatrix.needsUpdate = true;
        //await this.scene.add(this.closestPointsObj);
        //this.closestPointsObj = mesh;
      } catch (error) {
        console.error(error);
      }
    },

    //Read 3d object file from local directory
    getFileLocally(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = async e => {
        this.file = await e.target.result;
        this.fileName = await file.name;
      };
      reader.readAsDataURL(file);
    },
    //Read pos file from local directory
    getPosFile(e) {
      const posFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = async e => {
        this.posFile = await e.target.result;
        this.posFileName = await posFile.name;
      };
      reader.readAsText(posFile);
    },
    //Read algorithm file from lacal directory
    getAlgorithmLocally(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = async e => {
        this.algoFile = await e.target.result;
        this.algoFileName = await file.name;
      };
      reader.readAsDataURL(file);
    },
    //Remove files on the server
    clearRemoteFile(option) {
      // if (option == 1)
      //   axios.post(`http://${this.remoteIp}:${this.remotePort}/clear`, {
      //     fileName: this.fileName
      //   });
      // else if (option == 2)
      //   axios.post(`http://${this.remoteIp}:${this.remotePort}/clear`, {
      //     fileName: this.posFileName
      //   });
      // else if (option == 3)
      //   axios.post(`http://${this.remoteIp}:${this.remotePort}/clear`, {
      //     fileName: this.fileName.split(".")[0] + "-colp.gltf"
      //   });
      // else if (option == 4)
      //   axios.post(`http://${this.remoteIp}:${this.remotePort}/clear`, {
      //     fileName: this.fileName.split(".")[0] + "-ints.gltf"
      //   });
    },

    async initHeatmapGeo() {
      const responseHeatmapVerticesURL = await axios.get(
        this.heatmapVerticesURL
      );
      // console.log("response =", responseHeatmapVerticesURL.data);

      const responseHeatmapFacesURL = await axios.get(this.heatmapFacesURL);
      // console.log("response =", responseHeatmapFacesURL);

      // var objectFromFile = new THREE.Group();
      var heatmapGeo = new THREE.Geometry();

      for (let i = 0; i < responseHeatmapVerticesURL.data.length; i++) {
        heatmapGeo.vertices.push(
          new THREE.Vector3(
            responseHeatmapVerticesURL.data[i][0],
            responseHeatmapVerticesURL.data[i][1],
            responseHeatmapVerticesURL.data[i][2]
          )
        );
      }

      for (let i = 0; i < responseHeatmapFacesURL.data.length; i++) {
        heatmapGeo.faces.push(
          new THREE.Face3(
            responseHeatmapFacesURL.data[i][0],
            responseHeatmapFacesURL.data[i][1],
            responseHeatmapFacesURL.data[i][2]
          )
        );
      }

      this.heatmapObj = new THREE.Mesh(
        heatmapGeo,
        new THREE.MeshBasicMaterial({
          vertexColors: THREE.VertexColors
        })
      );

      await this.scene.add(this.heatmapObj);
      await this.targetList.push(this.heatmapObj);

      await this.applyAverageColor();
      await this.initColorMap(
        this.lowerBound.timingAverage.toFixed(2),
        this.upperBound.timingAverage.toFixed(2)
      );

      this.heatmapObj.geometry.elementsNeedUpdate = true;
    },
    //Initialize the 3d scene
    initScene() {
      this.parentContainer = document.getElementById("3dParent");
      this.container = document.getElementById("3d");

      this.textContainer = document.getElementById("textContainer");

      this.camera = new THREE.PerspectiveCamera(
        60,
        this.parentContainer.clientWidth / this.parentContainer.clientHeight,
        0.01,
        1e10
      );
      this.camera.position.z = 5;

      this.scene = new THREE.Scene();
      //this.scene.background = new THREE.Color(0x33334a);
      this.scene.background = new THREE.Color(0xffffff);

      const ambientLight = new THREE.AmbientLight(0xcccccc, 0.4);
      this.scene.add(ambientLight);

      const pointLight = new THREE.PointLight(0xffffff, 0.8);
      this.camera.add(pointLight);
      this.scene.add(this.camera);

      this.resultLoader = new GLTFLoader();

      //Instantiate renderer
      this.renderer = new THREE.WebGLRenderer();

      //Set the orbit control
      this.orbitControl = new OrbitControls(
        this.camera,
        this.renderer.domElement
      );
      this.orbitControl.enableDamping = true;
      this.orbitControl.dampingFactor = 0.25;
      this.orbitControl.enableZoom = true;
      this.orbitControl.update();

      //Config renderer
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(
        this.parentContainer.clientWidth,
        this.parentContainer.clientHeight
      );

      //Append 3D area to the DOM
      this.container.appendChild(this.renderer.domElement);
    },
    //3JS Renderer
    renderHeatMap() {
      this.camera.lookAt(this.scene.position);
      this.renderer.render(this.scene, this.camera);
    },
    //Set animation
    animateHeatMap() {
      requestAnimationFrame(this.animateHeatMap);
      this.orbitControl.update();
      this.renderHeatMap();
    },
    //This will call initial function and animate function
    showHeatMap() {
      this.initClosestPoints();
      this.loadResults();
      this.initScene();
      this.initHeatmapGeo();
      this.animateHeatMap();
    },
    //Wireframe mode toggler
    async switchWireframeMode() {
      this.wireframeMode = await !this.wireframeMode;
      let mode = await this.wireframeMode;
      await this.heatmapObj.traverse(function(child) {
        if (child instanceof THREE.Mesh) {
          child.geometry.computeFaceNormals();
          child.material.wireframe = mode;
          child.material.side = THREE.DoubleSide;
        }
      });
    },
    // Toggle closest points
    toggleClosestPoints() {
      if (this.viewClosestPoints) {
        this.viewClosestPoints = false;
        this.scene.remove(this.closestPointsObj);
      } else {
        this.viewClosestPoints = true;
        this.scene.add(this.closestPointsObj);
      }
    },

    // Toggle closest points
    toggleObject() {
      if (this.viewObject) {
        this.viewObject = false;
        this.scene.remove(this.heatmapObj);
      } else {
        this.viewObject = true;
        this.scene.add(this.heatmapObj);
      }
    },

    //Display mode toggler
    switchHeatmapMode2() {
      switch (this.heatmapMode) {
        case heatmapModes.TIMING.AVERAGE:
          this.heatmapMode = heatmapModes.TIMING.MEDIAN;
          this.displaySummary = this.vertTimeSummary;
          this.initColorMap(
            this.lowerBound.timingMedian.toFixed(2),
            this.upperBound.timingMedian.toFixed(2)
          );

          this.applyMedianColor();
          // console.log(this.heatmapObj);
          // console.log(this.verticesInfo);
          // console.log(this.upperBound);
          // console.log(this.filteredUpperBound);
          // console.log(this.filteredUpperBound);
          break;
        case heatmapModes.TIMING.FILTERAVERAGE:
          this.filterOutliersMode = false;
          this.heatmapMode = heatmapModes.TIMING.MEDIAN;
          this.displaySummary = this.vertTimeSummary;
          this.initColorMap(
            this.lowerBound.timingMedian.toFixed(2),
            this.upperBound.timingMedian.toFixed(2)
          );
          this.applyMedianColor();
          // console.log(this.heatmapObj);
          break;
        case heatmapModes.TIMING.MEDIAN:
          this.heatmapMode = heatmapModes.TIMING.MIN;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMin.toFixed(2),
            this.upperBound.timingMin.toFixed(2)
          );
          this.applyMinColor();
          // console.log(this.heatmapObj);
          break;
        case heatmapModes.TIMING.FILTERMEDIAN:
          this.filterOutliersMode = false;
          this.heatmapMode = heatmapModes.TIMING.MIN;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMin.toFixed(2),
            this.upperBound.timingMin.toFixed(2)
          );
          this.applyMinColor();
          // console.log(this.heatmapObj);
          break;
        case heatmapModes.TIMING.MIN:
          this.heatmapMode = heatmapModes.TIMING.MAX;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMax.toFixed(2),
            this.upperBound.timingMax.toFixed(2)
          );
          this.applyMaxColor();
          // console.log(this.heatmapObj);
          break;
        case heatmapModes.TIMING.FILTERMIN:
          this.filterOutliersMode = false;
          this.heatmapMode = heatmapModes.TIMING.MAX;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMax.toFixed(2),
            this.upperBound.timingMax.toFixed(2)
          );
          this.applyMaxColor();
          // console.log(this.heatmapObj);
          break;
        case heatmapModes.TIMING.MAX:
          this.heatmapMode = heatmapModes.TIMING.SD;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingSD.toFixed(2),
            this.upperBound.timingSD.toFixed(2)
          );
          this.applySDColor();
          break;
        case heatmapModes.TIMING.FILTERMAX:
          this.filterOutliersMode = false;
          this.heatmapMode = heatmapModes.TIMING.SD;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingSD.toFixed(2),
            this.upperBound.timingSD.toFixed(2)
          );
          this.applySDColor();
          break;
        case heatmapModes.TIMING.SD:
          this.heatmapMode = heatmapModes.TIMING.MEDIANAD;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMedianAD.toFixed(2),
            this.upperBound.timingMedianAD.toFixed(2)
          );
          this.applyMedianADColor();
          break;
        case heatmapModes.TIMING.FILTERSD:
          this.filterOutliersMode = false;
          this.heatmapMode = heatmapModes.TIMING.MEDIANAD;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMedianAD.toFixed(2),
            this.upperBound.timingMedianAD.toFixed(2)
          );
          this.applyMedianADColor();
          break;
        case heatmapModes.TIMING.MEDIANAD:
          this.heatmapMode = heatmapModes.DENSITY;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            Math.floor(this.lowerBound.density),
            Math.floor(this.upperBound.density)
          );
          this.applyDensityColor();
          break;
        case heatmapModes.TIMING.FILTERMEDIANAD:
          this.filterOutliersMode = false;
          this.heatmapMode = heatmapModes.DENSITY;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            Math.floor(this.lowerBound.density),
            Math.floor(this.upperBound.density)
          );
          this.applyDensityColor();
          break;
        case heatmapModes.DENSITY:
          this.heatmapMode = heatmapModes.TIMING.AVERAGE;
          this.displaySummary = this.vertInstSummary;
          this.scaleBarMode = " (density of closest points) ";
          this.initColorMap(
            this.lowerBound.timingAverage.toFixed(2),
            this.upperBound.timingAverage.toFixed(2)
          );
          this.applyAverageColor();
          break;
        case heatmapModes.FILTERDENSITY:
          this.filterOutliersMode = false;
          this.heatmapMode = heatmapModes.TIMING.AVERAGE;
          this.displaySummary = this.vertInstSummary;
          this.scaleBarMode = " (density of closest points) ";
          this.initColorMap(
            this.lowerBound.timingAverage.toFixed(2),
            this.upperBound.timingAverage.toFixed(2)
          );
          this.applyAverageColor();
          break;
      }
    },

    async switchFilterOutliersMode() {
      this.filterOutliersMode = await !this.filterOutliersMode;
      switch (this.heatmapMode) {
        case heatmapModes.TIMING.AVERAGE:
          this.heatmapMode = heatmapModes.TIMING.FILTERAVERAGE;
          this.displaySummary = this.vertTimeSummary;
          this.initColorMap(
            this.filteredLowerBound.timingAverage.toFixed(2),
            this.filteredUpperBound.timingAverage.toFixed(2)
          );
          this.applyAverageColorFiltered();
          break;
        case heatmapModes.TIMING.FILTERAVERAGE:
          this.heatmapMode = heatmapModes.TIMING.AVERAGE;
          this.displaySummary = this.vertTimeSummary;
          this.initColorMap(
            this.lowerBound.timingAverage.toFixed(2),
            this.upperBound.timingAverage.toFixed(2)
          );
          this.applyAverageColor();
          break;

        case heatmapModes.TIMING.MEDIAN:
          this.heatmapMode = heatmapModes.TIMING.FILTERMEDIAN;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.filteredLowerBound.timingMedian.toFixed(2),
            this.filteredUpperBound.timingMedian.toFixed(2)
          );
          // this.initColorMap(
          //   Math.floor(this.filteredLowerBound.timingMedian),
          //   Math.floor(this.filteredUpperBound.timingMedian)
          // );
          this.applyMedianColorFiltered();
          break;
        case heatmapModes.TIMING.FILTERMEDIAN:
          this.heatmapMode = heatmapModes.TIMING.MEDIAN;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMedian.toFixed(2),
            this.upperBound.timingMedian.toFixed(2)
          );
          this.applyMedianColor();
          break;

        case heatmapModes.TIMING.MIN:
          this.heatmapMode = heatmapModes.TIMING.FILTERMIN;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.filteredLowerBound.timingMin.toFixed(2),
            this.filteredUpperBound.timingMin.toFixed(2)
          );
          this.applyMinColorFiltered();
          break;
        case heatmapModes.TIMING.FILTERMIN:
          this.heatmapMode = heatmapModes.TIMING.MIN;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMin.toFixed(2),
            this.upperBound.timingMin.toFixed(2)
          );
          this.applyMinColor();
          break;

        case heatmapModes.TIMING.MAX:
          this.heatmapMode = heatmapModes.TIMING.FILTERMAX;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.filteredLowerBound.timingMax.toFixed(2),
            this.filteredUpperBound.timingMax.toFixed(2)
          );
          this.applyMaxColorFiltered();
          break;
        case heatmapModes.TIMING.FILTERMAX:
          this.heatmapMode = heatmapModes.TIMING.MAX;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMax.toFixed(2),
            this.upperBound.timingMax.toFixed(2)
          );
          this.applyMaxColor();
          break;

        case heatmapModes.TIMING.SD:
          this.heatmapMode = heatmapModes.TIMING.FILTERSD;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.filteredLowerBound.timingSD.toFixed(2),
            this.filteredUpperBound.timingSD.toFixed(2)
          );
          this.applySDColorFiltered();
          break;
        case heatmapModes.TIMING.FILTERSD:
          this.heatmapMode = heatmapModes.TIMING.SD;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingSD.toFixed(2),
            this.upperBound.timingSD.toFixed(2)
          );
          this.applySDColor();
          break;

        case heatmapModes.TIMING.MEDIANAD:
          this.heatmapMode = heatmapModes.TIMING.FILTERMEDIANAD;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.filteredLowerBound.timingMedianAD.toFixed(2),
            this.filteredUpperBound.timingMedianAD.toFixed(2)
          );
          this.applyMedianADColorFiltered();
          break;
        case heatmapModes.TIMING.FILTERMEDIANAD:
          this.heatmapMode = heatmapModes.TIMING.MEDIANAD;
          this.displaySummary = this.vertTimeSummary;
          this.scaleBarMode = " (Runtime in millisecond) ";
          this.initColorMap(
            this.lowerBound.timingMedianAD.toFixed(2),
            this.upperBound.timingMedianAD.toFixed(2)
          );
          this.applyMedianADColor();
          break;

        case heatmapModes.DENSITY:
          this.heatmapMode = heatmapModes.FILTERDENSITY;
          this.displaySummary = this.vertInstSummary;
          this.scaleBarMode = " (density of closest points) ";
          this.initColorMap(
            Math.floor(this.filteredLowerBound.density),
            Math.floor(this.filteredUpperBound.density)
          );
          this.applyDensityColorFiltered();
          break;
        case heatmapModes.FILTERDENSITY:
          this.heatmapMode = heatmapModes.DENSITY;
          this.displaySummary = this.vertInstSummary;
          this.scaleBarMode = " (density of closest points) ";
          this.initColorMap(
            Math.floor(this.lowerBound.density),
            Math.floor(this.upperBound.density)
          );
          this.applyDensityColor();
          break;
      }
    },

    //Froce reload the page
    reloadPage() {
      location.reload();
    },
    onDocumentMouseDown(event) {
      // the following line would stop any other event handler from firing
      // (such as the mouse's TrackballControls)

      // update the mouse variable
      this.mouse.x =
        ((event.clientX - this.parentContainer.offsetLeft) /
          this.parentContainer.clientWidth) *
          2 -
        1;
      this.mouse.y =
        1 -
        ((event.clientY - this.parentContainer.offsetTop) /
          this.parentContainer.clientHeight) *
          2;

      this.textContainer.style.top = event.clientY + "px";
      this.textContainer.style.left = event.clientX + "px";

      // create a Ray with origin at the mouse position
      let ray = new THREE.Raycaster();

      ray.setFromCamera(this.mouse, this.camera);

      // create an array containing all objects in the scene with which the ray intersects
      let intersects = ray.intersectObjects(this.targetList);
      // if there is one (or more) intersections
      if (intersects.length > 0) {
        this.isHover = true;
        // const tempCmpTime = [
        //   this.vertexInfo[intersects[0].face.a].vertTime,
        //   this.vertexInfo[intersects[0].face.b].vertTime,
        //   this.vertexInfo[intersects[0].face.c].vertTime
        // ];
        // const tempCmpInst = [
        //   this.vertexInfo[intersects[0].face.a].vertInts,
        //   this.vertexInfo[intersects[0].face.b].vertInts,
        //   this.vertexInfo[intersects[0].face.c].vertInts
        // ];
        // console.log(intersects[0]);
        // console.log(this.verticesInfo[intersects[0].face.a]
        //   );

        const timingAverageValue = this.verticesInfo[intersects[0].face.a]
          .vertexTimingAverage;
        const timingMedianValue = this.verticesInfo[intersects[0].face.a]
          .vertexTimingMedian;
        const timingMinValue = this.verticesInfo[intersects[0].face.a]
          .vertexTimingMin;
        const timingMaxValue = this.verticesInfo[intersects[0].face.a]
          .vertexTimingMax;
        const timingSDValue = this.verticesInfo[intersects[0].face.a]
          .vertexTimingSD;
        const timingMeanADValue = this.verticesInfo[intersects[0].face.a]
          .vertexTimingMeanAD;
        const timingMedianADValue = this.verticesInfo[intersects[0].face.a]
          .vertexTimingMedianAD;
        const densityValue = this.verticesInfo[intersects[0].face.a]
          .vertexDensity;

        switch (this.heatmapMode) {
          case heatmapModes.TIMING.AVERAGE:
            this.hoverValue = timingAverageValue;
            this.textContainer.innerHTML = `${this.hoverValue.toFixed(4) +
              " ms"}`;
            break;
          case heatmapModes.TIMING.MEDIAN:
            this.hoverValue = timingMedianValue;
            this.textContainer.innerHTML = `${this.hoverValue.toFixed(4) +
              " ms"}`;
            break;
          case heatmapModes.TIMING.MIN:
            this.hoverValue = timingMinValue;
            this.textContainer.innerHTML = `${this.hoverValue.toFixed(4) +
              " ms"}`;
            break;
          case heatmapModes.TIMING.MAX:
            this.hoverValue = timingMaxValue;
            this.textContainer.innerHTML = `${this.hoverValue.toFixed(4) +
              " ms"}`;
            break;
          case heatmapModes.TIMING.SD:
            this.hoverValue = timingSDValue;
            this.textContainer.innerHTML = `${this.hoverValue.toFixed(4) +
              " ms"}`;
            break;
          case heatmapModes.TIMING.MEANAD:
            this.hoverValue = timingMeanADValue;
            this.textContainer.innerHTML = `${this.hoverValue.toFixed(4) +
              " ms"}`;
            break;
          case heatmapModes.TIMING.MEDIANAD:
            this.hoverValue = timingMedianADValue;
            this.textContainer.innerHTML = `${this.hoverValue.toFixed(4) +
              " ms"}`;
            break;
          case heatmapModes.DENSITY:
            this.hoverValue = densityValue;
            this.textContainer.innerHTML = `${this.hoverValue + " point(s)"}`;
            break;
        }

        // let avgTimeOnFace;
        // if (!this.dispMode){
        //   avgTimeOnFace = Math.max(...tempCmpTime);
        //   this.hoverValue = avgTimeOnFace;
        // } else {
        //   /Math.max(...tempCmpInst);
        //   this.hoverValue = Math.round(avgTimeOnFace);
        // }
        // let avgTimeOnFace = !this.dispMode
        //   ?
        //   :
        //  = !this.dispMode
        //   ? avgTimeOnFace
        //   :
        intersects[0].object.geometry.colorsNeedUpdate = true;
        // this.textContainer.innerHTML = `${
        //   // !this.dispMode
        //   //   ? this.hoverValue.toFixed(4) + " ms"
        //   //   : Math.round(this.hoverValue) + " intersection(s)"
        // }`;
      } else {
        this.isHover = false;
        this.textContainer.innerHTML =
          "Please click on the surface of the 3D object";
      }

      if (this.isHover) {
        this.textContainer.style.visibility = "visible";
      } else {
        this.textContainer.style.visibility = "hidden";
      }
    }
  }
};
</script>

<style scoped>
.progress {
  border-radius: 0;
}
.box {
  height: 100%;
  width: 100%;
}
.file-name {
  color: rgb(155, 155, 155);
}
.err {
  color: rgb(197, 43, 43);
}

.success {
  color: rgb(70, 156, 30);
}
.sized {
  width: 80vw;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.loading-box {
  padding: 20px 20px 0px 20px;
  width: 100%;
  position: fixed;
  z-index: 50;
  display: flexbox; /* NEW, Spec - Firefox, Chrome, Opera */
  justify-content: center;
  align-items: center;
  height: 99%;
  background-color: white;
}
.dark-bg {
  background-image: linear-gradient(to right, rgb(27, 27, 27), #33334a);
  color: aliceblue;
  padding: 40px 40px 40px 40px !important;
  height: 100%;
}
.result {
  height: 100%;
}

.white {
  color: rgb(235, 235, 235);
}

.progress-icon {
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
  margin-bottom: 50px;
  display: block;
}

.progress-text {
  text-align: center;
  margin-left: 20px;
  margin-bottom: 30px;
}

.notification-text {
  text-align: center;
}

.scale-bar {
  margin-top: -15px;
  border-width: 3px;
  border-style: solid;
  border-radius: 3px;
  border-color: white;
  position: relative;
  left: 8.5%;
  height: 50px;
  width: 83%;
  background-image: linear-gradient(
    to left,
    hsl(0, 100%, 50%),
    hsl(60, 100%, 50%),
    hsl(120, 100%, 50%),
    hsl(180, 100%, 50%),
    hsl(240, 100%, 50%)
  ); /* Standard syntax (must be last) */
}
.scale-indicator {
  background-color: white;
  height: 30px;
  width: 1px;
  position: relative;
  left: 50%;
}

.text-indicator {
  text-align: center;
}

#textContainer {
  /* width: 100px;
     height: 40px; */
  font-size: 18px;
  background: rgba(255, 255, 255, 0.767);
  border-style: solid;
  border-width: 2px;
  border-color: gray;
  color: black;
  position: absolute;
  border-radius: 10px;
  pointer-events: none;
  padding: 5px 10px 5px 10px;
  display: inline-block;
}

#colorMap {
  /* width: 100px;
     height: 40px; */
  font-size: 18px;
  background: rgba(255, 255, 255, 0.767);
  border-style: solid;
  border-width: 2px;
  border-color: gray;
  color: black;
  position: absolute;
  top: 25%;
  right: 1%;
  border-radius: 10px;
  pointer-events: none;
  padding: 3px 3px 3px 3px;
  display: inline-block;
}

.logo {
  height: 150px;
  width: 150px;
  display: block;
  margin: 0 auto 40px auto;
}

@media only screen and (max-width: 786px) {
  .dark-bg {
    background-image: linear-gradient(to bottom, rgb(27, 27, 27), #33334a);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue